import React, { Component } from "react";
import { can } from "../../utils/permission";
import {
  GET,
  PUT,
  loading,
  alert,
  NavbarAdmin,
  Modal,
  Select,
  t, // นำเข้าฟังก์ชัน t
  format_date
} from "../../components/CustomComponent.js";
import ActivityModal from "../../components/ActivityModal.js";
import { compareLabels } from "../../utils/helpers";

// ความสูงกลางของทุกปุ่ม/ช่องเลือกบนแถบเครื่องมือ ให้เรียงกันแล้วดูเป็นแถวเดียว
const TOOLBAR_CONTROL = { height: 40 };

// ความกว้างคงที่ของคอลัมน์ในตารางตาราง (โหมดเดือนมี 31 คอลัมน์ ต้องเลื่อนแนวนอนแทนการบีบให้พอดีจอ
// ไม่งั้นข้อความในการ์ดงานจะถูกตัดเหลือ "O..." และปุ่ม "วางงานที่นี่" จะตัดเป็น 3 บรรทัด)
const DAY_COLUMN_WIDTH = 150;
// ความสูงคงที่ของทุกช่องวัน (ตัดปัญหาช่องยืดไม่เท่ากันเมื่อบางช่องมีงาน/วันหยุด/กิจกรรมเยอะ)
// เนื้อหาที่เกินพอดีเลื่อนดูได้ในช่อง (overflowY auto) แทนการดันให้ทั้งแถวสูงขึ้น
const DAY_CELL_HEIGHT = 152;
// จำนวนการ์ดงานสูงสุดที่โชว์ต่อช่อง เกินจากนี้ยุบเป็น "+N งาน" (ISS: จัดตารางงาน)
const MAX_JOBS_PER_CELL = 2;
const TECH_COLUMN_WIDTH = 220;
// ความสูงของ NavbarAdmin (wrapper .hpx-50, ตัว navbar เป็น position-fixed) ใช้เป็น top ของแถบงานที่ยังไม่มอบหมายที่ปักค้างไว้
const NAVBAR_HEIGHT = 50;
// หัวตารางวันที่ปักค้างบนสุดของกล่องตารางที่เลื่อนแนวตั้งเอง (พื้นทึบกันเนื้อตารางทะลุ)
// zIndex: หัววัน 3 < มุมหัวคอลัมน์ช่าง 4 (ค้างสองแกน) · ทั้งคู่ต่ำกว่าแถบ unassigned (10)
const STICKY_DAY_HEADER = {
    position: "sticky",
    top: 0,
    zIndex: 3,
    boxShadow: "0 2px 6px -4px rgba(0,0,0,0.25)",
};
// จำนวนแถวช่างที่ต้องเห็นตั้งแต่เปิดหน้า (ลูกค้าอาจขอเพิ่มภายหลัง แก้ค่าเดียวนี้)
const DEFAULT_VISIBLE_TECH_ROWS = 3;
// ความสูงแถวหัวตาราง (ช่างเทคนิค + วันที่) โดยประมาณ
const GRID_HEADER_HEIGHT = 70;
// กล่องตารางสูงอย่างน้อยเท่านี้ (หัวตาราง + DEFAULT_VISIBLE_TECH_ROWS แถว) ตอนกด "ดูทั้งหมด" จะลดเพดานความสูงรายการ unassigned แทนการดันกล่องตารางจนซ้อนใต้แถบ
// พื้นต่ำสุดจริงของกล่องตาราง: ค่าที่วัดได้ = ความสูงสูงสุดที่หัววันที่ไม่จมใต้แถบ unassigned ตอนเลื่อนหน้าสุด จึงห้ามดันเกินนี้ (จอเตี้ยถอยเหลือเท่าที่ที่รับได้ ไม่ต่ำกว่า 260)
const LEGACY_MIN_GRID_SCROLL_HEIGHT = 260;
// เป้า 3 แถว ใช้กันที่ให้ตอนลดเพดานรายการ unassigned (ดูทั้งหมด) เท่านั้น
const MIN_GRID_SCROLL_HEIGHT = GRID_HEADER_HEIGHT + DEFAULT_VISIBLE_TECH_ROWS * DAY_CELL_HEIGHT;
// เพดานรายการ unassigned ตอนดูทั้งหมด (สัดส่วนจอ) และต่ำสุดที่ยังเห็นการ์ดได้
const UNASSIGNED_LIST_MAX_VH = 0.4;
const UNASSIGNED_LIST_MIN_HEIGHT = 60;
// คอลัมน์ช่างปักไว้ซ้ายสุดเสมอ เลื่อนตารางไปขวาแล้วยังรู้ว่าแถวนี้ของใคร
const STICKY_TECH_COLUMN = {
    position: "sticky",
    left: 0,
    zIndex: 2,
    width: TECH_COLUMN_WIDTH,
    minWidth: TECH_COLUMN_WIDTH,
    boxShadow: "2px 0 6px -4px rgba(0,0,0,0.25)",
};

const TECHNICIAN_COLORS = ["#198754", "#fd7e14", "#0d6efd", "#6f42c1", "#d63384", "#0d6efd", "#6c757d"];
// ค่าพิเศษของฟิลเตอร์ช่าง - ไม่ใช่ uid ของใคร จึงชนกับช่างจริงไม่ได้
const FILTER_MY_TEAM = "my_team";
// ผู้ใช้ที่ล็อกอินอยู่ - ใช้เทียบกับ supervisor ของช่างเพื่อหาว่าใครเป็น "ลูกน้องของฉัน"
// (หน้าสร้างผู้ใช้/ช่างเป็นคนกำหนดผู้บังคับบัญชา backend ส่งกลับมาเป็น supervisor_id ซึ่งเป็น uid ของ user)
const getCurrentUserUid = () => {
    try {
        return JSON.parse(localStorage.getItem("cm-profile") || "null")?.uid || "";
    } catch (e) {
        return "";
    }
};
const COMPLETED_VISIT_STATUSES = ["completed", "success", "approved", "closed"];
// visit ที่ไม่ได้เข้าพื้นที่แล้ว - ไม่ต้องนับตอนเช็กวันซ้ำของ WO เดียวกัน
const INACTIVE_VISIT_STATUSES = ["cancelled", "canceled", "cancel", "rejected"];
// จำนวนแถวช่างที่แสดงต่อครั้ง - บริษัทที่มีช่างหลายร้อยคนจะไม่ต้อง render ทั้งบอร์ดพร้อมกัน
// (500 คน x 31 คอลัมน์ = 15,500 เซลล์ ทำให้หน้าค้าง) กดปุ่ม "แสดงเพิ่ม" ทีละชุด หรือ "แสดงทั้งหมด" ได้
const TECH_PAGE_SIZE = 20;
// วิธีเรียงแถวช่าง - ค่าเริ่มต้นเรียงตามชื่อ ก-ฮ (ลูกค้าขอ) จะหาคนที่ว่าง/ดูตามทักษะค่อยสลับจาก dropdown
const SORT_NAME = "name";
const SORT_WORKLOAD_ASC = "workload_asc";
const SORT_WORKLOAD_DESC = "workload_desc";
const SORT_SKILL = "skill";
const DEFAULT_SORT_MODE = SORT_NAME;
// แท็บบนตารางช่าง: ปัจจุบัน (ข้อมูลจริง) / แบบร่าง AI (งานที่ AI จัดให้ ยังไม่บันทึกจนกว่าจะกดยืนยัน)
const BOARD_TAB_CURRENT = "current";
const BOARD_TAB_AI_DRAFT = "ai_draft";
// AI แนะนำ: หาช่องว่างให้แต่ละงานภายในกี่วันข้างหน้า (เริ่มนับจากวันถัดไป)
const AI_DRAFT_WINDOW_DAYS = 14;
// เวลาที่โชว์หน้าโหลดตอนกด AI แนะนำ (ms) - ให้ผู้ใช้เห็นว่าระบบกำลังวิเคราะห์ ไม่ใช่กดแล้วเด้งทันที
const AI_GENERATING_MS = 5000;
const AI_GENERATING_STEPS = ["ai_step_collect_jobs", "ai_step_match_skills", "ai_step_history_rating", "ai_step_workload_slots", "ai_step_summarize"];
const FULL_DAY_SLOT = "09:00 - 17:00";
const MORNING_SLOT = "08:00 - 12:00";
const AFTERNOON_SLOT = "13:00 - 17:00";
// น้ำหนักคะแนนของ AI แนะนำ - ปรับตัวเลขตรงนี้ที่เดียว logic จะเปลี่ยนตาม
const AI_WEIGHT = {
  skillExact: 40, // ทักษะตรงรุ่นเครื่องของ asset ในใบงาน
  skillPartial: 15, // ทักษะยี่ห้อ/ซีรีส์เดียวกัน หรือชื่อรุ่นใกล้เคียง
  noModelInfo: 10, // ใบงานไม่ระบุรุ่นเครื่อง - ให้กลาง ๆ ทุกคนแล้วตัดสินด้วยเกณฑ์อื่น
  experiencePerVisit: 5, // เคยทำรุ่นนี้เสร็จมาแล้วครั้งละ +5 (สูงสุด experienceMax)
  experienceMax: 20,
  sameCustomer: 10, // เคยเข้าลูกค้ารายนี้
  ratingPerPoint: 5, // (คะแนนเฉลี่ย - 3) x 5 -> ช่วง -10 ถึง +10
  openJobPenalty: 6, // งานค้างในคิวตั้งแต่พรุ่งนี้ งานละ -6
  dayOffsetPenalty: 3, // ยิ่งได้คิวช้า ยิ่งลบ วันละ -3
};

export default class Scheduling extends Component {
  // ช่วงเวลาเริ่มต้นเมื่อ visit ยังไม่มีเวลา (ใช้ตอนลาก-วาง)
  visitTimeOptions = ["09:00 - 17:00", "08:00 - 12:00", "13:00 - 17:00"];

  constructor(props) {
    super(props);
    this.state = {
      technicians: [],
      scheduleDays: [],
      unassignedJobs: [],
      workOrders: [],
      showAllUnassigned: false,
      weekStartDate: this.getWeekStart(new Date()),
      // ช่วงเวลาที่แสดงบนตาราง: สัปดาห์ / เดือน (ISS-022) - โหมด "วันนี้" ถูกตัดออกแล้ว
      rangeMode: "week",
      // ช่างทั้งหมดที่ดึงมา (ไว้ทำ dropdown) แยกจาก technicians ที่ผ่านฟิลเตอร์แล้ว
      allTechnicians: [],
      filterTechnicianUid: "",
      sortMode: DEFAULT_SORT_MODE,
      boardTab: BOARD_TAB_CURRENT,
      // ผลจากปุ่ม AI แนะนำ: { generatedAt, startDate, assignments: [], unmatched: [] } - null = ยังไม่ได้กด
      aiDraft: null,
      // หน้าโหลดของ AI แนะนำ: กำลังคำนวณอยู่ไหม + ขั้นตอนที่โชว์อยู่ (index ของ AI_GENERATING_STEPS)
      aiGenerating: false,
      aiGeneratingStep: 0,
      // การ์ดในแบบร่างที่กดดูรายละเอียดอยู่ (เปิด modal) - null = ปิด
      draftDetail: null,
      // จำนวนแถวช่างที่เปิดดูอยู่ - เพิ่มทีละ TECH_PAGE_SIZE และรีเซ็ตเมื่อเปลี่ยนฟิลเตอร์/การเรียง
      visibleTechCount: TECH_PAGE_SIZE,
      dragOverKey: "",
      hoveredUnassignedKey: "",
      // กิจกรรมล่วงหน้าของช่าง (การ์ด teal อ่อนบนตาราง) - มาจาก admin/activities ตามช่วงวันที่ที่ตารางแสดงอยู่
      activities: [],
      // ช่างดิบ (จาก admin/technicians) + วัตถุประสงค์ของกิจกรรม ไว้ให้ ActivityModal ใช้ตอนกดแก้ไข/ลบกิจกรรมบน chip
      rawTechnicians: [],
      activityObjectives: [],
      activityModalOpen: false,
      activityModalActivity: null,
      // วันหยุดที่มีผลจริงต่อช่างแต่ละคน (รวมวันหยุดประจำสัปดาห์แล้ว) จาก admin/holidays/effective
      // เก็บเป็น Map<technicianUid, Map<fullDate, effectiveHoliday>> ไว้ query ตอน render แต่ละช่องเร็ว ๆ
      techHolidayMap: new Map(),
    };
  }

  getUnassignedJobKey = (job) => `${job.workOrderUid}_${job.visitUid}`;

  handleUnassignedMouseEnter = (jobKey) => {
    if (this.state.hoveredUnassignedKey !== jobKey) {
      this.setState({ hoveredUnassignedKey: jobKey });
    }
  };

  handleUnassignedMouseLeave = (jobKey) => {
    this.setState((prevState) => (prevState.hoveredUnassignedKey === jobKey ? { hoveredUnassignedKey: "" } : null));
  };

  async componentDidMount() {
    await this.restoreViewFromQuery();
    await this.fetchSchedulingData();
  }

  // กลับมาจากหน้าใบงาน (ปิด modal) -> URL มี week/range/tech/sort ที่ฝากไว้ตอนออกไป ให้กลับมาที่มุมมองเดิม
  // อ่านแล้วล้างออกจาก URL ทันที กัน refresh แล้วติดค่าเก่า (แบบร่าง AI กู้คืนไม่ได้ เพราะอยู่แค่ในหน่วยความจำของหน้า)
  restoreViewFromQuery = async () => {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    if (!["week", "range", "tech", "sort"].some((key) => params.has(key))) return;

    const rangeMode = params.get("range") === "month" ? "month" : "week";
    const weekParam = params.get("week") || "";
    const parsedWeek = /^\d{4}-\d{2}-\d{2}$/.test(weekParam) ? new Date(`${weekParam}T00:00:00`) : null;
    const anchorDate = parsedWeek && !Number.isNaN(parsedWeek.getTime()) ? parsedWeek : new Date();
    const weekStartDate = rangeMode === "month" ? this.getMonthStart(anchorDate) : this.getWeekStart(anchorDate);
    const sortParam = params.get("sort") || "";
    const sortMode = [SORT_NAME, SORT_WORKLOAD_ASC, SORT_WORKLOAD_DESC, SORT_SKILL].includes(sortParam) ? sortParam : DEFAULT_SORT_MODE;

    // รอให้ state ลงจริงก่อน (setState ใน componentDidMount ถูก batch) ไม่งั้น fetchSchedulingData จะอ่านสัปดาห์เดิม
    await new Promise((resolve) => this.setState({ rangeMode, weekStartDate, sortMode, filterTechnicianUid: params.get("tech") || "" }, resolve));

    ["week", "range", "tech", "sort"].forEach((key) => params.delete(key));
    window.history.replaceState({}, "", url.pathname + url.search + url.hash);
  };

  // URL สำหรับกลับมาหน้านี้ที่สัปดาห์/มุมมอง/ฟิลเตอร์เดิม - ฝากไปกับหน้าใบงานใน param "return"
  buildReturnUrl = () => {
    const { weekStartDate, rangeMode, filterTechnicianUid, sortMode } = this.state;
    const params = new URLSearchParams();
    params.set("week", this.getFullDate(weekStartDate));
    params.set("range", rangeMode);
    if (filterTechnicianUid) params.set("tech", filterTechnicianUid);
    if (sortMode && sortMode !== DEFAULT_SORT_MODE) params.set("sort", sortMode);
    return `/ad/scheduling?${params.toString()}`;
  };

  // คลิกการ์ดงาน (งานที่ยังไม่มอบหมาย / การ์ดบนตาราง) -> ไปหน้าใบงาน เปิด modal ใบนั้นและเลือก visit ที่กดค้างไว้
  // ใช้ UI ของหน้าใบงานตัวจริงแทน popup ของหน้านี้ (ตัดสินใจ 2026-10-14) ปิด modal แล้วหน้าใบงานพากลับมาที่นี่ตาม return
  openWorkOrderPage = async (job) => {
    if (!job?.workOrderUid) return;

    // มีแบบร่าง AI ที่ยังไม่ยืนยัน: ออกจากหน้าแล้วแบบร่างหาย ถามก่อน
    if (this.state.aiDraft) {
      const confirmed = await alert("", "question", t("confirm"), t("ai_draft_discard_question"), t("confirm"), t("cancel"));
      if (!confirmed) return;
    }

    const params = new URLSearchParams();
    params.set("uid", job.workOrderUid);
    if (job.visitUid) params.set("visit", job.visitUid);
    params.set("return", this.buildReturnUrl());
    window.location.href = `/ad/work-orders?${params.toString()}`;
  };

  componentWillUnmount() {
    this.clearAiTimers();
    if (this.gridObserver) this.gridObserver.disconnect();
    if (this.gridScrollObserver) this.gridScrollObserver.disconnect();
    if (this.gridRaf) cancelAnimationFrame(this.gridRaf);
    window.removeEventListener("resize", this.scheduleGridUpdate);
  }

  // กล่องตารางเลื่อนแนวตั้งเอง (จำเป็นเพื่อให้หัววันที่ sticky ได้ เพราะ .table-responsive มี overflow-x)
  // ความสูง = จอ - navbar - แถบ unassigned (ที่ปักค้าง) - ช่องว่างใต้กล่อง วัดจริงทั้งหมด
  // เพื่อให้ตอนเลื่อนหน้าสุด ขอบบนกล่องจอดพอดีใต้แถบ unassigned หัววันที่จึงไม่ถูกแถบบังเมื่อเลื่อนหน้าต่อ
  setUnassignedRef = (el) => {
    if (this.gridObserver) this.gridObserver.disconnect();
    this.unassignedEl = el;
    if (el && typeof ResizeObserver !== "undefined") {
      this.gridObserver = new ResizeObserver(this.scheduleGridUpdate);
      this.gridObserver.observe(el);
    }
    window.removeEventListener("resize", this.scheduleGridUpdate);
    if (el) window.addEventListener("resize", this.scheduleGridUpdate);
    this.scheduleGridUpdate();
  };

  // ResizeObserver แก้ขนาด element ข้างในที่ตัวเองสังเกตอยู่ จึงต้องเลื่อนไปทำเฟรมถัดไป (ไม่งั้นเกิด "ResizeObserver loop" error) และยกเลิกอันเก่าก่อน
  scheduleGridUpdate = () => {
    if (this.gridRaf) cancelAnimationFrame(this.gridRaf);
    this.gridRaf = requestAnimationFrame(() => {
      this.gridRaf = null;
      this.updateGridMaxHeight();
    });
  };

  setUnassignedListRef = (el) => {
    this.unassignedListEl = el;
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.showAllUnassigned !== this.state.showAllUnassigned) this.scheduleGridUpdate();
    // วัดซ้ำเมื่อข้อมูลที่กระทบความสูงเปลี่ยน (ตอน mount ข้อมูลยังไม่มา ค่าที่วัดได้จึงยังไม่นิ่ง)
    const { technicians, unassignedJobs, visibleTechCount } = this.state;
    if (
      prevState.technicians !== technicians ||
      (prevState.unassignedJobs || []).length !== (unassignedJobs || []).length ||
      prevState.visibleTechCount !== visibleTechCount
    ) {
      this.scheduleGridUpdate();
    }
  }

  setGridScrollRef = (el) => {
    if (this.gridScrollObserver) this.gridScrollObserver.disconnect();
    this.gridScrollEl = el;
    if (el && typeof ResizeObserver !== "undefined") {
      this.gridScrollObserver = new ResizeObserver(this.scheduleGridUpdate);
      this.gridScrollObserver.observe(el);
      this.gridScrollObserver.observe(document.body);
    }
    // ฟอนต์โหลดเสร็จแล้วความสูงแถบ/หัวตารางเปลี่ยน
    if (el && document.fonts && document.fonts.ready) document.fonts.ready.then(this.scheduleGridUpdate);
    this.scheduleGridUpdate();
  };

  updateGridMaxHeight = () => {
    const el = this.gridScrollEl;
    if (!el) return;
    const bottomGap = Math.max(0, document.documentElement.scrollHeight - (el.getBoundingClientRect().bottom + window.scrollY));
    const listEl = this.unassignedListEl;
    if (listEl && this.unassignedEl) {
      if (this.state.showAllUnassigned) {
        // รายการสูงได้ไม่เกิน 40vh และต้องเหลือที่ให้กล่องตารางอย่างน้อย MIN_GRID_SCROLL_HEIGHT
        listEl.style.maxHeight = "none";
        const chrome = this.unassignedEl.offsetHeight - listEl.offsetHeight;
        const room = window.innerHeight - NAVBAR_HEIGHT - 24 - bottomGap - MIN_GRID_SCROLL_HEIGHT - chrome;
        listEl.style.maxHeight = `${Math.max(UNASSIGNED_LIST_MIN_HEIGHT, Math.min(window.innerHeight * UNASSIGNED_LIST_MAX_VH, room))}px`;
      } else {
        listEl.style.maxHeight = "";
      }
    }
    // แถบมี mb-4 (24px) กั้นระหว่างแถบกับกล่อง ตอนเลื่อนสุดกล่องจึงมีที่เผื่อใต้แถบอยู่แล้ว เหลือกันไว้แค่ 4px ให้หัววันไม่ชนแถบ
    const stickyHeight = this.unassignedEl ? this.unassignedEl.offsetHeight + 4 : 0;
    const height = Math.max(LEGACY_MIN_GRID_SCROLL_HEIGHT, window.innerHeight - NAVBAR_HEIGHT - stickyHeight - bottomGap);
    el.style.maxHeight = `${height}px`;
  };

  clearAiTimers = () => {
    if (this.aiStepTimer) clearInterval(this.aiStepTimer);
    if (this.aiDoneTimer) clearTimeout(this.aiDoneTimer);
    this.aiStepTimer = null;
    this.aiDoneTimer = null;
  };

  // API ส่งวันเวลาเป็น ISO แบบมี timezone (เช่น 2026-09-04T17:00:00.000Z = 05/09 00:00 เวลาไทย)
  // ถ้าตัดสตริงตรง ๆ จะได้วัน/เวลาแบบ UTC ซึ่งผิดไป 1 วันสำหรับ visit ที่เวลาก่อน 07:00
  // -> ทำให้การ์ดขึ้นผิดวัน และเช็ก "WO เดียวกันห้ามลงวันซ้ำ" เตือนทั้งที่วันนั้นไม่มีงาน จึงแปลงเป็นเวลาเครื่องก่อน
  // ส่วนค่าแบบไม่มี timezone ("2026-09-05 09:00:00" / "2026-09-05") ใช้ตามตัวอักษรเหมือนเดิม
  hasTimezone = (value) => /(?:Z|[+-]\d{2}:?\d{2})$/i.test(value);

  toLocalDate = (value) => {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
  };

  getDatePart = (dateTime) => {
    if (!dateTime) return "";
    const value = String(dateTime).trim();
    if (value.includes("T") && this.hasTimezone(value)) {
      const localDate = this.toLocalDate(value);
      if (localDate) return this.getFullDate(localDate);
    }
    if (value.includes("T")) return value.split("T")[0];
    if (value.includes(" ")) return value.split(" ")[0];
    return value;
  };

  getTimePart = (dateTime) => {
    if (!dateTime) return "";
    const value = String(dateTime).trim();
    if (value.includes("T") && this.hasTimezone(value)) {
      const localDate = this.toLocalDate(value);
      if (localDate) {
        return `${String(localDate.getHours()).padStart(2, "0")}:${String(localDate.getMinutes()).padStart(2, "0")}:${String(localDate.getSeconds()).padStart(2, "0")}`;
      }
    }
    let timePart = "";

    if (value.includes("T")) {
      timePart = value.split("T")[1] || "";
    } else if (value.includes(" ")) {
      timePart = value.split(" ")[1] || "";
    }

    if (!timePart) return "";
    timePart = timePart.split("Z")[0].split("+")[0].split("-")[0].trim();
    const [hours = "00", minutes = "00", seconds = "00"] = timePart.split(":");
    return `${hours.padStart(2, "0")}:${minutes.padStart(2, "0")}:${seconds.padStart(2, "0")}`;
  };

  buildTimeSlot = (startDate, endDate) => {
    const startTime = this.formatTime(startDate);
    const endTime = this.formatTime(endDate);
    if (!startTime || !endTime) return "";
    return `${startTime} - ${endTime}`;
  };

  // แก้ไขได้เฉพาะ visit ที่สถานะเป็น open เท่านั้น
  isVisitOpenStatus = (status) => String(status || "open").trim().toLowerCase() === "open";

  fetchSchedulingData = async () => {
    loading(true);
    const scheduleDays = this.getScheduleDays(this.state.weekStartDate, this.state.rangeMode);
    const rangeStart = scheduleDays[0]?.fullDate;
    const rangeEnd = scheduleDays[scheduleDays.length - 1]?.fullDate;
    // page: 0 = ไม่ใส่ limit ฝั่ง backend (ดู technician.service.js / work-order.service.js)
    // เดิม hardcode page_size 10/20 ทำให้ตารางแสดงช่างได้แค่ 10 คนและงานแค่ 20 ใบแรก (ISS-022)
    const [techResult, woResult, modelResult, holidayResult, activityResult, objectiveResult] = await Promise.all([
      GET("admin/technicians", {
        page: 0,
        uid: "",
        type: "",
        data_search: "",
      }),
      GET("admin/work-orders", {
        page: 0,
        uid: "",
        data_search: "",
      }),
      // ทักษะช่าง (technician_skill.item) เก็บเป็น uid ของรุ่นเครื่องพิมพ์ ต้องดึง models มาแปลงเป็นชื่อ
      // เหมือนหน้าจัดการช่าง (technicians.js) ไม่งั้นบนบอร์ดจะเห็นเป็น uid ยาว ๆ หรือไม่ขึ้นเลย
      GET("warehouse/models", { page_size: 100000, page: 0 }),
      // วันหยุดที่มีผลจริงต่อช่างแต่ละคนในช่วงที่ตารางแสดง (รวมวันหยุดประจำสัปดาห์แล้ว) - ย้อมพื้นหลังช่อง
      GET("admin/holidays/effective", { start_date: rangeStart, end_date: rangeEnd }),
      // กิจกรรมล่วงหน้าของช่าง (endpoint ใหม่ - ถ้ายัง deploy ไม่ถึงจะได้ status:false ตกไปใช้ค่าว่างตามปกติ)
      GET("admin/activities", { start_date: rangeStart, end_date: rangeEnd }),
      // วัตถุประสงค์ของกิจกรรมช่าง (ใช้ในฟอร์มแก้ไขกิจกรรม)
      GET("admin/objectives", { usage_type: "technician", page: 0, page_size: 10000 }),
    ]);

    const technicians = techResult?.status && Array.isArray(techResult.data) ? techResult.data : [];
    const workOrders = woResult?.status && Array.isArray(woResult.data) ? woResult.data : [];
    const models = modelResult?.status && Array.isArray(modelResult.data) ? modelResult.data : [];
    const modelNameByUid = new Map(models.map((model) => [model.uid, model.name]));
    const activities = activityResult?.status && Array.isArray(activityResult.data) ? activityResult.data : [];
    const activityObjectives = objectiveResult?.status && Array.isArray(objectiveResult.data) ? objectiveResult.data : [];
    const techHolidayMap = this.buildTechHolidayMap(holidayResult?.status ? holidayResult.data : null);

    const { mappedTechnicians, unassignedJobs } = this.buildSchedule(technicians, workOrders, scheduleDays, modelNameByUid);

    this.setState({
      allTechnicians: mappedTechnicians,
      technicians: this.applyTechnicianFilter(mappedTechnicians, this.state.filterTechnicianUid),
      scheduleDays,
      unassignedJobs,
      workOrders: workOrders,
      activities,
      rawTechnicians: technicians,
      activityObjectives,
      techHolidayMap,
      // ข้อมูลจริงเปลี่ยน (มอบหมาย/ย้ายงานสำเร็จ) แบบร่างเดิมอาจชนกับของจริง ให้ล้างแล้วกดสร้างใหม่
      aiDraft: null,
      boardTab: BOARD_TAB_CURRENT,
    });

    loading(false);
  };

  // GET admin/holidays/effective -> { technicians: [{ technician:{uid}, effective:[{date, source, name, ...}] }] }
  // "effective" ของแต่ละช่างรวมวันหยุดบริษัท + วันหยุดของตัวเอง (ถ้าชนวันเดียวกันใช้ของช่างทับ) ไว้แล้วจาก backend
  // แปลงเป็น Map<technicianUid, Map<fullDate, holiday>> ให้ query ตอน render แต่ละช่องได้เร็ว ๆ โดยไม่ loop ซ้ำ
  buildTechHolidayMap = (data) => {
    const map = new Map();
    const technicians = Array.isArray(data?.technicians) ? data.technicians : [];
    technicians.forEach((entry) => {
      const uid = entry?.technician?.uid;
      if (!uid) return;
      const byDate = new Map();
      (Array.isArray(entry.effective) ? entry.effective : []).forEach((holiday) => {
        if (holiday?.date) byDate.set(holiday.date, holiday);
      });
      map.set(uid, byDate);
    });
    return map;
  };

  // วันหยุดที่มีผลจริงของช่างคนนี้ในวันนี้ (ถ้ามี) - source "company" = วันหยุดบริษัท(รวมประจำสัปดาห์), "technician" = วันหยุดส่วนตัว/ลา
  getTechHoliday = (technicianUid, fullDate) => this.state.techHolidayMap.get(technicianUid)?.get(fullDate) || null;

  openActivityModal = (activity) => this.setState({ activityModalOpen: true, activityModalActivity: activity });

  closeActivityModal = () => this.setState({ activityModalOpen: false });

  // กิจกรรมล่วงหน้าของช่างคนนี้ที่คาบวันที่นี้อยู่ (ไม่ล็อกการมอบหมายงาน แสดงเป็นข้อมูลประกอบเท่านั้น)
  getTechActivities = (technicianUid, fullDate) =>
    (this.state.activities || []).filter(
      (activity) =>
        fullDate >= activity.start_date &&
        fullDate <= activity.end_date &&
        (activity.technicians || []).some((tech) => tech.uid === technicianUid)
    );

  // ป้ายเวลาของกิจกรรม - มีเวลาเฉพาะกิจกรรมวันเดียว (time_start/time_end null เมื่อคาบหลายวัน)
  getActivityTimeLabel = (activity) => {
    if (activity.time_start && activity.time_end) return `${activity.time_start}-${activity.time_end}`;
    if (activity.time_start) return activity.time_start;
    return "";
  };

  // ช่างที่มีผู้ใช้ที่ล็อกอินอยู่เป็นผู้บังคับบัญชา - "ลูกน้องของฉัน"
  getMyTeamTechnicians = (list = []) => {
    const myUid = getCurrentUserUid();
    if (!myUid) return [];
    return list.filter((tech) => tech.supervisor_id && tech.supervisor_id === myUid);
  };

  // กรองแถวช่างที่แสดงบนตาราง - ไม่ยิง API ใหม่ เพราะข้อมูลทั้งหมดถูกดึงมาแล้ว
  // ค่าที่รับได้: "" = ทั้งหมด, FILTER_MY_TEAM = เฉพาะลูกน้องของฉัน, นอกนั้นถือเป็น uid ของช่างรายคน
  applyTechnicianFilter = (list, technicianUid) => {
    if (!technicianUid) return list;
    if (technicianUid === FILTER_MY_TEAM) return this.getMyTeamTechnicians(list);
    return list.filter((tech) => tech.uid === technicianUid);
  };

  // ตัวเลือกใน dropdown ฟิลเตอร์ช่าง
  // ตัวเลือก "ลูกน้องของฉัน (n)" มีเสมอแม้ n = 0 เพื่อให้ผู้ใช้รู้ว่ามีฟิลเตอร์นี้ให้ใช้
  // ถ้ามีลูกน้อง รายชื่อจะจัดกลุ่มเป็น ลูกน้องของฉัน / ช่างอื่น ๆ ถ้าไม่มีก็เป็นลิสต์เรียบเหมือนเดิม
  getTechnicianFilterOptions = () => {
    const { allTechnicians } = this.state;
    const myTeam = this.getMyTeamTechnicians(allTechnicians);
    const myTeamUids = new Set(myTeam.map((tech) => tech.uid));

    // ใช้ค่า "all" แทนค่าว่าง เพราะ <Select> ถือว่าค่าว่าง = ยังไม่ได้เลือก แล้วจะโชว์ placeholder แทน
    const options = [
      { value: "all", label: `${t("all_technicians")} (${allTechnicians.length})` },
      { value: FILTER_MY_TEAM, label: `${t("my_team_technicians")} (${myTeam.length})` },
    ];
    // Select ถูกสั่ง sort={false} (เพื่อให้ "ทั้งหมด" อยู่บนสุด) จึงเรียงรายชื่อช่าง ก-ฮ เองตรงนี้
    const toOption = (tech, group) => ({ value: tech.uid, label: tech.filter_label || tech.name, ...(group ? { group } : {}) });
    const byLabel = (a, b) => compareLabels(a.label, b.label);

    if (!myTeam.length) {
      return [...options, ...allTechnicians.map((tech) => toOption(tech)).sort(byLabel)];
    }

    return [
      ...options,
      ...myTeam.map((tech) => toOption(tech, t("my_team_technicians"))).sort(byLabel),
      ...allTechnicians
        .filter((tech) => !myTeamUids.has(tech.uid))
        .map((tech) => toOption(tech, t("other_technicians")))
        .sort(byLabel),
    ];
  };

  changeTechnicianFilter = (technicianUid) => {
    this.setState((prev) => ({
      filterTechnicianUid: technicianUid,
      technicians: this.applyTechnicianFilter(prev.allTechnicians, technicianUid),
      visibleTechCount: TECH_PAGE_SIZE,
    }));
  };

  getSortOptions = () => [
    { value: SORT_NAME, label: t("sort_by_name") },
    { value: SORT_WORKLOAD_ASC, label: t("sort_most_available_first") },
    { value: SORT_WORKLOAD_DESC, label: t("sort_busiest_first") },
    { value: SORT_SKILL, label: t("sort_by_skill") },
  ];

  changeSortMode = (sortMode) => {
    this.setState({ sortMode: sortMode || DEFAULT_SORT_MODE, visibleTechCount: TECH_PAGE_SIZE });
  };

  showMoreTechnicians = () => {
    this.setState((prev) => ({ visibleTechCount: prev.visibleTechCount + TECH_PAGE_SIZE }));
  };

  showAllTechnicians = () => {
    this.setState({ visibleTechCount: Number.MAX_SAFE_INTEGER });
  };

  // จำนวนงาน/ความคืบหน้าของช่างคนหนึ่งเฉพาะในช่วงวันที่แสดงอยู่บนตาราง
  // คำนวณตอน render ไม่ใช่ตอนดึงข้อมูล เพราะกดลูกศรเลื่อนสัปดาห์/เดือนไม่ได้ยิง API ใหม่
  // (เดิมป้าย "n งาน" ค้างค่าจากช่วงแรกที่โหลด และเรียงตามภาระงานจะผิดช่วง)
  getVisibleStats = (tech, dateKeys) => {
    const visibleJobs = dateKeys.reduce((acc, dateKey) => acc.concat(tech.schedule[dateKey] || []), []);
    const count = visibleJobs.length;
    const completedCount = visibleJobs.filter((job) => COMPLETED_VISIT_STATUSES.includes(String(job.status || "").toLowerCase())).length;
    const utilPercent = count > 0 ? Math.round((completedCount / count) * 100) : 0;
    return { jobsTotal: count, jobsCount: `${count} ${t("jobs")}`, utilText: `${utilPercent}%` };
  };

  // เรียงแถวช่าง - ช่างที่ลา/ปิดใช้งานไปอยู่ท้ายสุดเสมอ ไม่ว่าจะเลือกเรียงแบบไหน
  sortTechnicians = (list, sortMode) => {
    const byName = (a, b) => String(a.name || "").localeCompare(String(b.name || ""), "th");
    const bySkill = (a, b) => {
      // ช่างที่ไม่มีทักษะไปอยู่ท้ายกลุ่ม แล้วค่อยไล่ตามชื่อ
      if (!a.primarySkill && b.primarySkill) return 1;
      if (a.primarySkill && !b.primarySkill) return -1;
      return String(a.primarySkill || "").localeCompare(String(b.primarySkill || ""), "th") || byName(a, b);
    };
    const comparators = {
      [SORT_WORKLOAD_ASC]: (a, b) => a.jobsTotal - b.jobsTotal || byName(a, b),
      [SORT_WORKLOAD_DESC]: (a, b) => b.jobsTotal - a.jobsTotal || byName(a, b),
      [SORT_SKILL]: bySkill,
      [SORT_NAME]: byName,
    };
    const compare = comparators[sortMode] || comparators[DEFAULT_SORT_MODE];
    // แท็บแบบร่าง AI: ช่างที่ AI เลือกให้งานขึ้นบนสุด เรียงตามจำนวนงานที่ได้ (มาก -> น้อย)
    // เท่ากันดูคะแนน AI สูงสุด แล้วค่อยใช้การเรียงที่เลือกไว้ - จะได้ไล่ตรวจ/แก้แบบร่างต่อได้ทันทีไม่ต้องเลื่อนหา
    const byDraft = (a, b) => (b.draftCount || 0) - (a.draftCount || 0) || (b.draftMaxScore || 0) - (a.draftMaxScore || 0);
    return [...list].sort((a, b) => Number(Boolean(a.isLeave)) - Number(Boolean(b.isLeave)) || byDraft(a, b) || compare(a, b));
  };

  // สถิติงานที่ AI ลงให้ช่างคนนี้ในแบบร่าง (จำนวน + คะแนนสูงสุด) - ใช้จัดลำดับแถวบนแท็บแบบร่าง
  getDraftStats = (tech) => {
    const drafted = (this.state.aiDraft?.assignments || []).filter((assignment) => assignment.technicianUid === tech.uid);
    return {
      draftCount: drafted.length,
      draftMaxScore: drafted.reduce((max, assignment) => Math.max(max, Number(assignment.aiScore) || 0), 0),
    };
  };

  // แถวช่างที่ผ่านฟิลเตอร์แล้ว + สถิติของช่วงที่แสดง + เรียงตามที่เลือก (ยังไม่ตัดจำนวน)
  getDisplayedTechnicians = () => {
    const { technicians, scheduleDays, sortMode } = this.state;
    const dateKeys = (scheduleDays || []).map((day) => day.fullDate);
    const isDraftTab = this.isDraftTab();
    const withStats = (technicians || []).map((tech) => {
      const merged = isDraftTab ? { ...tech, schedule: this.getDraftSchedule(tech), ...this.getDraftStats(tech) } : tech;
      return { ...merged, ...this.getVisibleStats(merged, dateKeys) };
    });
    return this.sortTechnicians(withStats, sortMode);
  };

  // ---------- AI แนะนำ (ทำงานฝั่ง frontend ทั้งหมดจากข้อมูลที่โหลดไว้แล้ว) ----------

  isDraftTab = () => this.state.boardTab === BOARD_TAB_AI_DRAFT && Boolean(this.state.aiDraft);

  changeBoardTab = (boardTab) => {
    this.setState({ boardTab, visibleTechCount: TECH_PAGE_SIZE });
  };

  getDraftAssignmentKey = (assignment) => `${assignment.workOrderUid}_${assignment.visitUid}`;

  // ตารางของช่างคนหนึ่งในมุมมองแบบร่าง = งานจริง + งานที่ AI ลงให้ (ติดธง isAiDraft ไว้ทำกรอบกะพริบ)
  getDraftSchedule = (tech) => {
    const { aiDraft } = this.state;
    const schedule = { ...(tech.schedule || {}) };
    (aiDraft?.assignments || [])
      .filter((assignment) => assignment.technicianUid === tech.uid)
      .forEach((assignment) => {
        schedule[assignment.fullDate] = [...(schedule[assignment.fullDate] || []), assignment];
      });
    return schedule;
  };

  getTomorrowFullDate = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return this.getFullDate(tomorrow);
  };

  addDays = (fullDate, days) => {
    const [year, month, day] = String(fullDate).split("-").map(Number);
    const date = new Date(year, month - 1, day + days);
    return this.getFullDate(date);
  };

  // แปลง SLA เริ่มงานเป็นชั่วโมงเพื่อจัดลำดับความเร่งด่วน (ไม่มี SLA = เร่งด่วนน้อยสุด)
  getSlaHours = (priority) => {
    const value = Number(priority?.sla_response_time_start);
    if (!value || Number.isNaN(value)) return Number.POSITIVE_INFINITY;
    const unit = String(priority?.sla_response_time_start_unit || "");
    if (unit.includes("วัน") || unit.toLowerCase().includes("day")) return value * 24;
    return value;
  };

  normalizeText = (value) => String(value || "").trim().toLowerCase();

  // งานที่ช่างมีอยู่แล้วในวันนั้น (ของจริง + แบบร่าง) - ไว้เช็กว่ายังลงเพิ่มได้ไหมและช่วงไหน
  getTechJobsOnDate = (tech, fullDate, draftAssignments) => [
    ...((tech.schedule || {})[fullDate] || []),
    ...draftAssignments.filter((assignment) => assignment.technicianUid === tech.uid && assignment.fullDate === fullDate),
  ];

  getJobTimeSlot = (job) => job.timeSlot || this.buildTimeSlot(job.start_date, job.end_date) || FULL_DAY_SLOT;

  // ช่วงเวลาที่ยังว่างในวันนั้น: ว่างทั้งวัน -> เต็มวัน, มีงานครึ่งวันอยู่แล้ว 1 งาน -> อีกครึ่ง, นอกนั้นถือว่าเต็ม
  getFreeSlotOnDate = (tech, fullDate, draftAssignments) => {
    const jobs = this.getTechJobsOnDate(tech, fullDate, draftAssignments).filter(
      (job) => !COMPLETED_VISIT_STATUSES.includes(String(job.status || "").toLowerCase())
    );
    if (jobs.length === 0) return FULL_DAY_SLOT;
    if (jobs.length > 1) return "";
    const existing = this.getJobTimeSlot(jobs[0]);
    if (existing === MORNING_SLOT) return AFTERNOON_SLOT;
    if (existing === AFTERNOON_SLOT) return MORNING_SLOT;
    return "";
  };

  // หาวันว่างเร็วสุดของช่างคนนี้สำหรับงานนี้ ตั้งแต่พรุ่งนี้ไปอีก AI_DRAFT_WINDOW_DAYS วัน
  findEarliestSlot = (tech, job, draftAssignments, startDate) => {
    for (let offset = 0; offset < AI_DRAFT_WINDOW_DAYS; offset += 1) {
      const fullDate = this.addDays(startDate, offset);
      // visit ของ WO เดียวกันห้ามลงวันเดียวกัน (ทั้งของจริงและที่ AI เพิ่งลงไปในแบบร่าง)
      if (this.hasOverlappingVisitDate(job.workOrderUid, job.visitUid, fullDate)) continue;
      if (draftAssignments.some((item) => item.workOrderUid === job.workOrderUid && item.fullDate === fullDate)) continue;
      const timeSlot = this.getFreeSlotOnDate(tech, fullDate, draftAssignments);
      if (timeSlot) return { fullDate, timeSlot, dayOffset: offset };
    }
    return null;
  };

  // ให้คะแนนช่างสำหรับงานหนึ่ง ๆ พร้อมเหตุผลเป็นข้อ ๆ (เอาไปโชว์ตอนกดการ์ดในแบบร่าง)
  scoreTechnicianForJob = (tech, job, draftAssignments, startDate) => {
    const reasons = [];
    let score = 0;
    const history = tech.history || {};
    const skillNames = (tech.skillNames || []).map(this.normalizeText).filter(Boolean);
    const modelName = this.normalizeText(job.modelName);
    const brandName = this.normalizeText(job.brandName);
    const serieName = this.normalizeText(job.serieName);

    // 1) ทักษะ (รุ่นเครื่องที่ชำนาญ) เทียบกับรุ่นเครื่องของ asset ในใบงาน
    if (!modelName) {
      score += AI_WEIGHT.noModelInfo;
      reasons.push(t("ai_reason_no_model_info"));
    } else if (skillNames.includes(modelName)) {
      score += AI_WEIGHT.skillExact;
      reasons.push(`${t("ai_reason_skill_exact")}: ${job.modelName}`);
    } else if (
      skillNames.some(
        (skill) => skill.includes(modelName) || modelName.includes(skill) || (brandName && skill.includes(brandName)) || (serieName && skill.includes(serieName))
      )
    ) {
      score += AI_WEIGHT.skillPartial;
      reasons.push(`${t("ai_reason_skill_partial")}: ${job.modelName}`);
    } else {
      reasons.push(`${t("ai_reason_skill_none")}: ${job.modelName}`);
    }

    // 2) ประสบการณ์กับรุ่นนี้ (นับจาก visit ที่ทำเสร็จแล้วในระบบ)
    const doneOnModel = modelName ? Number((history.models || {})[modelName] || 0) : 0;
    if (doneOnModel > 0) {
      score += Math.min(AI_WEIGHT.experienceMax, doneOnModel * AI_WEIGHT.experiencePerVisit);
      reasons.push(`${t("ai_reason_experience")} ${doneOnModel} ${t("times_unit")}`);
    }

    // 3) เคยเข้าลูกค้ารายนี้
    if (job.customerUid && (history.customers || {})[job.customerUid]) {
      score += AI_WEIGHT.sameCustomer;
      reasons.push(`${t("ai_reason_customer")} ${history.customers[job.customerUid]} ${t("times_unit")}`);
    }

    // 4) คะแนนที่ลูกค้าให้ (customer_rating บน visit ที่เสร็จแล้ว)
    if (history.ratingCount > 0) {
      const avg = history.ratingSum / history.ratingCount;
      score += Math.round((avg - 3) * AI_WEIGHT.ratingPerPoint);
      reasons.push(`${t("ai_reason_rating")} ${avg.toFixed(1)}/5 (${history.ratingCount} ${t("times_unit")})`);
    }

    // 5) ภาระงานในคิวตั้งแต่พรุ่งนี้ (ของจริงที่ยังไม่เสร็จ + ที่ AI เพิ่งลงให้ในแบบร่างนี้)
    const openUpcoming =
      Object.entries(tech.schedule || {})
        .filter(([fullDate]) => fullDate >= startDate)
        .reduce((acc, [, jobs]) => acc + jobs.filter((item) => !COMPLETED_VISIT_STATUSES.includes(String(item.status || "").toLowerCase())).length, 0) +
      draftAssignments.filter((item) => item.technicianUid === tech.uid).length;
    score -= openUpcoming * AI_WEIGHT.openJobPenalty;
    reasons.push(`${t("ai_reason_workload")} ${openUpcoming} ${t("jobs")}`);

    // 6) ช่องว่างเร็วสุด - ไม่มีเลยใน 14 วัน = ช่างคนนี้ไม่เข้าข่าย
    const slot = this.findEarliestSlot(tech, job, draftAssignments, startDate);
    if (!slot) return null;
    score -= slot.dayOffset * AI_WEIGHT.dayOffsetPenalty;
    reasons.push(`${t("ai_reason_earliest_slot")} ${format_date(slot.fullDate, "dd/mm/yyyy", "th")} ${slot.timeSlot}`);

    return { score: Math.max(0, Math.round(score)), reasons, slot };
  };

  generateAiDraft = async () => {
    const { allTechnicians, unassignedJobs } = this.state;
    // ลงได้เฉพาะ visit สถานะ open (เหมือนกติกาลากวาง) ช่างต้องยังใช้งานอยู่และไม่ได้ลา
    const jobs = (unassignedJobs || []).filter((job) => this.isVisitOpenStatus(job.status));
    const candidates = (allTechnicians || []).filter((tech) => tech.is_active !== false && !tech.isLeave);

    if (!jobs.length) {
      await alert("", "info", t("ai_suggest"), t("ai_draft_no_unassigned"));
      return;
    }
    if (!candidates.length) {
      await alert("", "warning", t("ai_suggest"), t("ai_draft_no_technician"));
      return;
    }

    // ถามยืนยันก่อนเริ่มวิเคราะห์ - บอกจำนวนงาน/ช่างที่จะเอาเข้าคิด และย้ำว่าเป็นแค่แบบร่าง ยังไม่บันทึก
    const confirmed = await alert(
      "",
      "question",
      t("ai_suggest"),
      `${t("ai_draft_generate_question")} (${jobs.length} ${t("jobs")} / ${candidates.length} ${t("technicians")})`,
      t("confirm"),
      t("cancel")
    );
    if (!confirmed) return;

    // โชว์หน้าโหลดพร้อมข้อความขั้นตอนประมาณ 5 วินาที แล้วค่อยคำนวณจริง (การคำนวณเองใช้เวลาไม่ถึงวินาที)
    this.clearAiTimers();
    this.setState({ aiGenerating: true, aiGeneratingStep: 0 });
    this.aiStepTimer = setInterval(() => {
      this.setState((prev) => ({ aiGeneratingStep: Math.min(prev.aiGeneratingStep + 1, AI_GENERATING_STEPS.length - 1) }));
    }, AI_GENERATING_MS / AI_GENERATING_STEPS.length);
    this.aiDoneTimer = setTimeout(() => {
      this.clearAiTimers();
      const aiDraft = this.buildAiDraft(jobs, candidates);
      this.setState({
        aiDraft,
        aiGenerating: false,
        boardTab: BOARD_TAB_AI_DRAFT,
        visibleTechCount: TECH_PAGE_SIZE,
      });
    }, AI_GENERATING_MS);
  };

  buildAiDraft = (jobs, candidates) => {
    const startDate = this.getTomorrowFullDate();
    // งานเร่งด่วน (SLA สั้น) ได้เลือกช่างก่อน แล้วค่อยไล่ตามวันที่เปิดใบงาน
    const orderedJobs = [...jobs].sort((a, b) => a.slaHours - b.slaHours || String(a.createdAt || "").localeCompare(String(b.createdAt || "")));
    const assignments = [];
    const unmatched = [];

    orderedJobs.forEach((job) => {
      let best = null;
      candidates.forEach((tech) => {
        const evaluated = this.scoreTechnicianForJob(tech, job, assignments, startDate);
        if (!evaluated) return;
        if (!best || evaluated.score > best.score) best = { tech, ...evaluated };
      });

      if (!best) {
        unmatched.push({ ...job, unmatchedReason: t("ai_unmatched_no_slot") });
        return;
      }

      assignments.push(this.buildDraftAssignment(job, best.tech, best.slot.fullDate, best.slot.timeSlot, best.score, best.reasons));
    });

    return { generatedAt: new Date(), startDate, assignments, unmatched };
  };

  // สร้าง object งานในแบบร่าง (รูปแบบเดียวกับการ์ดงานจริงบนตาราง + ธง isAiDraft)
  buildDraftAssignment = (job, tech, fullDate, timeSlot, aiScore, aiReasons, movedByUser = false) => {
    const [startTime, endTime] = timeSlot.split(" - ");
    return {
      ...job,
      isAiDraft: true,
      movedByUser,
      unmatchedReason: undefined,
      technicianUid: tech.uid,
      technicianName: tech.name,
      fullDate,
      timeSlot,
      time: startTime,
      start_date: `${fullDate} ${startTime}:00`,
      end_date: `${fullDate} ${endTime}:00`,
      hasSchedule: true,
      aiScore,
      aiReasons,
    };
  };

  // ลากงานในแท็บแบบร่าง (การ์ดที่ AI ลงให้ หรืองานที่ AI จัดไม่ได้) ไปวางช่อง/วันอื่น - แก้เฉพาะแบบร่าง
  // ทับซ้อนกับงานที่ช่างมีอยู่แล้ว (ของจริงหรือแบบร่าง) ไม่ห้าม แต่ถาม confirm ก่อน
  handleDraftDrop = async (job, technicianUid, targetFullDate) => {
    const { aiDraft, allTechnicians } = this.state;
    if (!aiDraft) return;

    if (targetFullDate < this.getTodayFullDate()) {
      await alert("", "warning", t("warning"), t("svp_validate_past_date"));
      return;
    }

    const jobKey = this.getUnassignedJobKey(job);
    const otherAssignments = aiDraft.assignments.filter((item) => this.getDraftAssignmentKey(item) !== jobKey);

    const technician = (allTechnicians || []).find((item) => item.uid === technicianUid);
    if (!technician) return;

    // WO เดียวกันห้ามมี visit วันเดียวกัน (ทั้งของจริงและในแบบร่าง) - บล็อก ไม่มีปุ่มยืนยัน
    const sameWoConflict = this.getSameWoDateConflictMessage(job, targetFullDate, otherAssignments);
    if (sameWoConflict) {
      await alert("", "warning", t("warning"), sameWoConflict);
      return;
    }

    // ช่างมีงานวันนั้นแล้ว ไม่ห้าม แค่ถามยืนยันครั้งเดียว
    const timeSlot = job.timeSlot || FULL_DAY_SLOT;
    const warnings = this.getOverlapWarnings(job, technician, targetFullDate, otherAssignments);
    if (warnings.length) {
      const confirmed = await this.confirmPlacement(`(${technician.name}, ${format_date(targetFullDate, "dd/mm/yyyy", "th")} ${timeSlot})`, warnings);
      if (!confirmed) return;
    }

    const moveReason = `${t("ai_reason_moved_by_user")}: ${technician.name} ${format_date(targetFullDate, "dd/mm/yyyy", "th")} ${timeSlot}`;
    const reasons = [...(job.aiReasons || []).filter((reason) => !reason.startsWith(t("ai_reason_moved_by_user"))), moveReason];
    const assignment = this.buildDraftAssignment(job, technician, targetFullDate, timeSlot, job.aiScore ?? 0, reasons, true);

    this.setState((prev) => {
      if (!prev.aiDraft) return null;
      return {
        aiDraft: {
          ...prev.aiDraft,
          assignments: [...prev.aiDraft.assignments.filter((item) => this.getDraftAssignmentKey(item) !== jobKey), assignment],
          unmatched: prev.aiDraft.unmatched.filter((item) => this.getUnassignedJobKey(item) !== jobKey),
        },
      };
    });
  };

  // กดการ์ดที่ AI ลงให้ -> โชว์เหตุผล และเลือกเอาออกจากแบบร่างได้ (งานจะกลับไปอยู่ในรายการที่ยังจัดไม่ได้)
  // กดการ์ดที่ AI ลงให้ -> เปิด modal รายละเอียด (งาน / ช่าง / วันเวลา / คะแนน / เหตุผล) เอาออกจากแบบร่างได้จากในนั้น
  showDraftAssignment = (assignment) => {
    this.setState({ draftDetail: assignment });
  };

  closeDraftDetail = () => {
    this.setState({ draftDetail: null });
  };

  removeDraftAssignment = (assignment) => {
    this.closeDraftDetail();
    this.setState((prev) => {
      if (!prev.aiDraft) return null;
      const key = this.getDraftAssignmentKey(assignment);
      const assignments = prev.aiDraft.assignments.filter((item) => this.getDraftAssignmentKey(item) !== key);
      const { isAiDraft, movedByUser, technicianUid, technicianName, aiScore, aiReasons, ...job } = assignment;
      const unmatched = [...prev.aiDraft.unmatched, { ...job, fullDate: "", hasSchedule: false, unmatchedReason: t("ai_unmatched_removed") }];
      return { aiDraft: { ...prev.aiDraft, assignments, unmatched } };
    });
  };

  discardAiDraft = async () => {
    const confirmed = await alert("", "question", t("confirm"), t("ai_draft_discard_question"), t("confirm"), t("cancel"));
    if (!confirmed) return;
    this.setState({ aiDraft: null, boardTab: BOARD_TAB_CURRENT, visibleTechCount: TECH_PAGE_SIZE });
  };

  // ปุ่มยืนยัน - เฟสนี้ทำเฉพาะ UI ยังไม่ยิง API (รอ backend endpoint สำหรับบันทึกหลายงานพร้อมกัน)
  confirmAiDraft = async () => {
    const count = this.state.aiDraft?.assignments?.length || 0;
    if (!count) {
      await alert("", "warning", t("warning"), t("ai_draft_nothing_to_confirm"));
      return;
    }
    const confirmed = await alert("", "question", t("ai_draft_confirm_button"), `${t("ai_draft_confirm_question")} (${count} ${t("jobs")})`, t("confirm"), t("cancel"));
    if (!confirmed) return;
    await alert("", "info", t("ai_draft_confirm_button"), t("ai_draft_confirm_pending"));
  };

  // สลับช่วงเวลา: สัปดาห์ = 7 วันเริ่มวันจันทร์, เดือน = ทั้งเดือนของวันที่อ้างอิง
  changeRangeMode = async (rangeMode) => {
    const today = new Date();
    const anchor = rangeMode === "month" ? this.getMonthStart(today) : this.getWeekStart(today);

    this.setState({ rangeMode, weekStartDate: anchor }, this.fetchSchedulingData);
  };

  handleDragStart = (event, job) => {
    // ไม่มีสิทธิ์ wo.update = ลากย้ายงานไม่ได้ (การลากคือการแก้ไขใบงาน)
    if (!can("wo.update") || !this.isVisitOpenStatus(job.status)) {
      event.preventDefault();
      return;
    }
    event.dataTransfer.effectAllowed = "move";
    event.dataTransfer.setData("application/json", JSON.stringify(job));
  };

  handleDragOver = (event, dateKey) => {
    // ห้ามวางลงวันที่ย้อนหลัง: ไม่เรียก preventDefault ทำให้ browser แสดง cursor "ห้ามวาง" และไม่ยิง onDrop
    if (dateKey && dateKey < this.getTodayFullDate()) return;
    event.preventDefault();
  };

  handleDragEnterCell = (cellKey, dateKey) => {
    if (dateKey && dateKey < this.getTodayFullDate()) return;
    if (this.state.dragOverKey !== cellKey) {
      this.setState({ dragOverKey: cellKey });
    }
  };

  handleDragLeaveCell = (event, cellKey) => {
    // ถ้า pointer ยังอยู่ใน element ลูกของ cell เดิม (เช่นกล่อง "Drop job here") ไม่ต้องเคลียร์ effect
    if (event.currentTarget.contains(event.relatedTarget)) return;
    this.setState((prevState) => (prevState.dragOverKey === cellKey ? { dragOverKey: "" } : null));
  };

  handleDrop = async (event, technicianUid, targetFullDate) => {
    event.preventDefault();
    event.stopPropagation();
    this.setState({ dragOverKey: "" });
    const payload = event.dataTransfer.getData("application/json");
    if (!payload) return;

    let job;
    try {
      job = JSON.parse(payload);
    } catch (err) {
      return;
    }

    if (!job || !job.workOrderUid || !job.visitUid) return;

    // ลากวางลงช่อง/วันที่เดิมที่มันอยู่แล้ว ไม่ต้องมี message เตือนหรือทำอะไรต่อ
    if (job.technicianUid === technicianUid && job.fullDate === targetFullDate) return;

    // แท็บแบบร่าง AI: ย้ายงานในแบบร่างเท่านั้น ไม่แตะข้อมูลจริง
    if (this.isDraftTab()) {
      await this.handleDraftDrop(job, technicianUid, targetFullDate);
      return;
    }

    if (!this.isVisitOpenStatus(job.status)) {
      await alert("", "warning", t("warning"), t("visit_only_open_editable"));
      return;
    }

    if (targetFullDate < this.getTodayFullDate()) {
      await alert("", "warning", t("warning"), t("svp_validate_past_date"));
      return;
    }

    // WO เดียวกันห้ามมี visit วันเดียวกัน - บล็อก ไม่มีปุ่มยืนยัน และไม่ยิง PUT
    const sameWoConflict = this.getSameWoDateConflictMessage(job, targetFullDate);
    if (sameWoConflict) {
      await alert("", "warning", t("warning"), sameWoConflict);
      return;
    }

    // ถ้า visit ยังไม่เคยมีเวลา ให้ default เป็นตัวเลือกแรกของ visitTimeOptions (09:00 - 17:00)
    const timeSlot = this.buildTimeSlot(job.start_date, job.end_date) || this.visitTimeOptions[0];

    // ใช้รายชื่อทั้งหมด ไม่ใช่รายการที่ผ่านฟิลเตอร์ ไม่งั้นมอบหมายให้ช่างที่ถูกกรองออกแล้วชื่อจะว่าง
    const technician = (this.state.allTechnicians || []).find((item) => item.uid === technicianUid);
    // ช่างมีงานวันนั้นแล้ว ไม่บล็อก - รวมคำเตือนไว้ใน confirm เดียวกับการมอบหมาย (WO เดียวกันวันซ้ำถูกบล็อกไปแล้วข้างบน)
    const warnings = this.getOverlapWarnings(job, technician, targetFullDate);
    const confirmed = await this.confirmPlacement(
      `${t("confirm_assign_job_desc")} (${technician?.name || ""}, ${targetFullDate ? format_date(targetFullDate, "dd/mm/yyyy", "th") : ""} ${timeSlot})`,
      warnings
    );
    if (!confirmed) return;

    loading(true);
    try {
      // ลากมาจากการ์ดที่ถูก assign ช่างอยู่แล้ว (ย้ายวัน/ย้ายช่าง) ให้แทนที่ช่างเดิม แทนที่จะเพิ่มช่างซ้อน
      const replaceTechnician = Boolean(job.technicianUid);
      const result = await this.updateWorkOrderVisitAssignment(job.workOrderUid, job.visitUid, technicianUid, targetFullDate, replaceTechnician, timeSlot);

      if (!result?.status) {
        console.error("Failed to assign technician to work order visit", result?.message);
        event.dataTransfer.clearData("application/json");
        return;
      }

      // ใช้ fetchSchedulingData แทนการ patch state เอง เพื่อให้การ์ดที่ถูกย้ายหลุดออกจากช่อง/ช่างเดิมถูกต้อง
      await this.fetchSchedulingData();
    } catch (err) {
      console.error("Failed to assign technician to work order visit", err);
    } finally {
      loading(false);
    }
  };

  toggleUnassignedView = () => {
    this.setState((prevState) => ({
      showAllUnassigned: !prevState.showAllUnassigned,
    }));
  };

  // ปุ่มลูกศรซ้าย/ขวา - ก้าวทีละ 1 สัปดาห์ / 1 เดือน ตามโหมดที่เลือกอยู่
  changeWeek = (weekOffset) => {
    const { rangeMode } = this.state;
    const newStart = new Date(this.state.weekStartDate);
    if (rangeMode === "month") newStart.setMonth(newStart.getMonth() + weekOffset);
    else newStart.setDate(newStart.getDate() + weekOffset * 7);
    const scheduleDays = this.getScheduleDays(newStart, rangeMode);
    this.setState({ weekStartDate: newStart, scheduleDays });
  };

  showCurrentWeek = () => {
    this.changeRangeMode(this.state.rangeMode);
  };

  formatWeekRange = (startDate) => {
    if (!startDate) return "";
    const { rangeMode } = this.state;
    if (rangeMode === "month") {
      return startDate.toLocaleDateString("en-US", { month: "long", year: "numeric" });
    }
    const endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + 6);

    const options = { month: "short", day: "numeric" };
    const startLabel = startDate.toLocaleDateString("en-US", options);
    const endLabel = endDate.toLocaleDateString("en-US", options);
    return `${startLabel} - ${endLabel}`;
  };

  getWeekStart = (date) => {
    const result = new Date(date);
    const dayIndex = result.getDay();
    const diffToMonday = dayIndex === 0 ? 6 : dayIndex - 1;
    result.setDate(result.getDate() - diffToMonday);
    result.setHours(0, 0, 0, 0);
    return result;
  };

  // visit ของ Work Order เดียวกันห้ามเลือกวันที่ทับกัน - คืน visit ที่ชน (หรือ null) เพื่อเอาไปบอกในข้อความเตือน
  // ไม่นับ visit ที่ยกเลิก/ถูกปฏิเสธแล้ว เพราะไม่ได้เข้าพื้นที่จริง
  findOverlappingVisit = (workOrderUid, visitUid, targetFullDate, excludeVisitUids = []) => {
    const workOrder = (this.state.workOrders || []).find((item) => item.uid === workOrderUid);
    if (!workOrder || !targetFullDate) return null;

    const visits = Array.isArray(workOrder.visits) ? workOrder.visits : [];
    return (
      visits.find(
        (visit) =>
          visit.uid !== visitUid &&
          !excludeVisitUids.includes(visit.uid) &&
          !INACTIVE_VISIT_STATUSES.includes(String(visit.status || "").toLowerCase()) &&
          this.getDatePart(visit.start_date) === targetFullDate
      ) || null
    );
  };

  hasOverlappingVisitDate = (workOrderUid, visitUid, targetFullDate) => Boolean(this.findOverlappingVisit(workOrderUid, visitUid, targetFullDate));

  // ข้อความบล็อกเมื่อ WO เดียวกันมี visit วันนั้นอยู่แล้ว (ของจริง หรือในแบบร่าง AI) - คืน "" ถ้าไม่ชน
  // visit ที่ถูกย้ายไปที่อื่นในแบบร่างแล้ว ไม่นับวันเดิมของมัน
  getSameWoDateConflictMessage = (job, targetFullDate, draftAssignments = []) => {
    if (!targetFullDate) return "";

    const movedVisitUids = draftAssignments.map((item) => item.visitUid);
    const overlappingVisit = this.findOverlappingVisit(job.workOrderUid, job.visitUid, targetFullDate, movedVisitUids);
    if (overlappingVisit) return `${t("visit_date_overlap_blocked")}\n\n${this.getOverlapMessage(overlappingVisit, targetFullDate)}`;

    const overlappingDraft = draftAssignments.find(
      (item) => item.workOrderUid === job.workOrderUid && item.visitUid !== job.visitUid && item.fullDate === targetFullDate
    );
    if (overlappingDraft) {
      return `${t("visit_date_overlap_blocked")}\n\n${t("visit_date_overlap_same_wo")}\n(${format_date(targetFullDate, "dd/mm/yyyy", "th")} | ${t("ai_draft_tab")} | ${t("technician")}: ${overlappingDraft.technicianName})`;
    }
    return "";
  };

  // รวมคำเตือนของการลงงานครั้งนี้ (ไม่บล็อก แค่เอาไปโชว์ใน confirm เดียวแล้วให้ผู้ใช้ตัดสินใจ)
  // ช่างปลายทางมีงานวันนั้นอยู่แล้ว (ของจริง + แบบร่าง) ยกเว้นงานที่กำลังย้ายเอง
  // (WO เดียวกันวันซ้ำ ไม่อยู่ที่นี่แล้ว - ห้ามเด็ดขาด ดู getSameWoDateConflictMessage)
  getOverlapWarnings = (job, technician, targetFullDate, draftAssignments = []) => {
    const warnings = [];
    if (!targetFullDate) return warnings;

    if (technician) {
      const busy = this.getTechJobsOnDate(technician, targetFullDate, draftAssignments).filter(
        (item) => item.visitUid !== job.visitUid && !COMPLETED_VISIT_STATUSES.includes(String(item.status || "").toLowerCase())
      );
      if (busy.length) {
        const list = busy.map((item) => `• ${this.getJobTimeSlot(item)} ${item.id} - ${item.title}`).join("\n");
        warnings.push(`${t("technician_busy_on_date")} (${technician.name}, ${format_date(targetFullDate, "dd/mm/yyyy", "th")})\n${list}`);
      }
    }
    return warnings;
  };

  // confirm เดียวสำหรับทุกการลงงาน: ถ้ามีคำเตือนทับซ้อนจะโชว์ไว้ด้านบนของคำถาม ยืนยันแล้วลงได้เหมือนเดิม
  confirmPlacement = async (question, warnings = []) => {
    const hasWarning = warnings.length > 0;
    const detail = hasWarning ? `${warnings.join("\n\n")}\n\n${t("overlap_confirm_question")}\n${question}` : question;
    return alert("", hasWarning ? "warning" : "question", hasWarning ? t("ai_draft_overlap_title") : t("confirm"), detail, t("confirm"), t("cancel"));
  };

  // ข้อความเตือนวันซ้ำ บอกด้วยว่าชนกับ visit ไหน (เลขที่/สถานะ/ช่างที่ถูกมอบหมาย) ให้ผู้ใช้ไปดูได้ถูกจุด
  // เพราะ visit ที่ชนอาจยังไม่มีช่าง (อยู่ในกล่องงานที่ยังไม่มอบหมาย) หรืออยู่ในแถวช่างที่ถูกกรอง/ยังไม่ได้แสดง
  getOverlapMessage = (visit, targetFullDate) => {
    const technicians = (Array.isArray(visit?.visits_technicians) ? visit.visits_technicians : [])
      .map((item) => item?.technician)
      .filter(Boolean)
      .map((tech) => this.getTechnicianName(tech))
      .join(", ");
    const detail = [
      format_date(targetFullDate, "dd/mm/yyyy", "th"),
      visit?.sequence ? `${t("visit")} ${visit.sequence}` : "",
      `${t("status")}: ${visit?.status || "-"}`,
      `${t("technician")}: ${technicians || t("unassigned")}`,
    ]
      .filter(Boolean)
      .join(" | ");
    return `${t("visit_date_overlap_same_wo")}\n(${detail})`;
  };

  updateWorkOrderVisitAssignment = async (workOrderUid, visitUid, technicianUid, targetFullDate, replaceTechnician = false, timeSlot = "") => {
    const workOrder = (this.state.workOrders || []).find((item) => item.uid === workOrderUid);
    if (!workOrder) {
      return { status: false, message: "Work order not found" };
    }

    const body = this.buildWorkOrderUpdatePayload(workOrder, visitUid, technicianUid, targetFullDate, replaceTechnician, timeSlot);
    return await PUT(`admin/work-orders/${workOrderUid}`, body);
  };

  combineDateAndTime = (dateString, targetFullDate) => {
    if (!targetFullDate) return dateString;

    const timePart = dateString ? this.getTimePart(dateString) : "";
    return `${targetFullDate} ${timePart || "00:00:00"}`;
  };

  buildVisitDateTime = (targetFullDate, time) => {
    if (!targetFullDate) return undefined;
    return `${targetFullDate} ${time || "00:00"}:00`;
  };

  buildWorkOrderUpdatePayload = (workOrder, visitUid, technicianUid, targetFullDate, replaceTechnician = false, timeSlot = "") => {
    const visits = Array.isArray(workOrder.visits) ? workOrder.visits : [];
    const [slotStartTime, slotEndTime] = timeSlot ? timeSlot.split(" - ") : [];

    const updatedVisits = visits.map((visit, index) => {
      const currentTechnicianUids = (Array.isArray(visit.visits_technicians) ? visit.visits_technicians : [])
        .map((technician) => technician?.technician?.uid || technician)
        .filter(Boolean);

      const visitsTechnicians = visit.uid === visitUid
        ? replaceTechnician
          ? [technicianUid]
          : Array.from(new Set([...currentTechnicianUids, technicianUid]))
        : currentTechnicianUids;

      const startDate = visit.uid === visitUid
        ? (timeSlot ? this.buildVisitDateTime(targetFullDate, slotStartTime) : this.combineDateAndTime(visit.start_date, targetFullDate))
        : visit.start_date;

      const endDate = visit.uid === visitUid
        ? (timeSlot ? this.buildVisitDateTime(targetFullDate, slotEndTime) : this.combineDateAndTime(visit.end_date, targetFullDate))
        : visit.end_date;

      return {
        uid: visit.uid,
        sequence: visit.sequence || index + 1,
        start_date: startDate,
        end_date: endDate,
        visits_technicians: visitsTechnicians,
      };
    });

    return {
      // ...workOrder,
      visits: updatedVisits,
    };
  };

  getFullDate = (date) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

  getTodayFullDate = () => this.getFullDate(new Date());

  getMonthStart = (date) => {
    const result = new Date(date.getFullYear(), date.getMonth(), 1);
    result.setHours(0, 0, 0, 0);
    return result;
  };

  // จำนวนคอลัมน์วันของตาราง ขึ้นกับช่วงเวลาที่เลือก (ISS-022)
  getRangeLength = (startDate, rangeMode) => {
    if (rangeMode === "month") {
      const reference = startDate ? new Date(startDate) : new Date();
      return new Date(reference.getFullYear(), reference.getMonth() + 1, 0).getDate();
    }
    return 7;
  };

  getScheduleDays = (startDate, rangeMode = this.state?.rangeMode || "week") => {
    const reference = startDate ? new Date(startDate) : new Date();
    const todayFullDate = this.getTodayFullDate();
    const weekdayKeys = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
    return Array.from({ length: this.getRangeLength(reference, rangeMode) }).map((_, offset) => {
      const date = new Date(reference);
      date.setDate(reference.getDate() + offset);
      const dayKey = weekdayKeys[date.getDay()];
      const localFullDate = this.getFullDate(date);
      const isToday = localFullDate === todayFullDate;
      // เสาร์-อาทิตย์เป็นวันทำงานปกติ ลงงานได้เหมือนวันอื่น (เดิมล็อกเป็น "หยุด" ทั้งคอลัมน์)
      return {
        day: t(dayKey),
        date: `${date.getDate()}`,
        fullDate: localFullDate,
        sub: isToday ? t("today") : "",
        isToday,
      };
    });
  };

  // ชื่อช่างที่ใช้ทั้งหน้า (ช่องแรกของตาราง, dropdown, การ์ดงาน): ไม่เอาคำนำหน้า
  // แสดง "ชื่อ นามสกุล (ชื่อเล่น)" ไม่มีชื่อเล่นก็ไม่ต้องใส่วงเล็บ ไม่มีชื่อเลยค่อยใช้รหัสช่าง
  getTechnicianName = (tech) => {
    const fullName =
      [tech.first_name_th, tech.last_name_th].filter(Boolean).join(" ") ||
      [tech.first_name_en, tech.last_name_en].filter(Boolean).join(" ");
    if (!fullName) return tech.technician_code || "Tech";
    const nickname = String(tech.nickname_th || tech.nickname_en || "").trim();
    return nickname ? `${fullName} (${nickname})` : fullName;
  };

  // ป้ายใน dropdown ฟิลเตอร์ช่าง - รูปแบบเดียวกับชื่อในตาราง
  getTechnicianFilterLabel = (tech) => {
    return this.getTechnicianName(tech);
  };

  getTechnicianInitials = (name) => {
    if (!name) return "--";
    const parts = name.split(" ").filter(Boolean);
    if (parts.length >= 2) return `${parts[0].charAt(0)}${parts[1].charAt(0)}`;
    return name.slice(0, 2).toUpperCase();
  };

  formatDateKey = (dateString) => {
    if (!dateString) return "";
    return this.getDatePart(dateString);
  };

  formatTime = (dateString) => {
    if (!dateString) return "";
    const time = this.getTimePart(dateString);
    if (!time) return "";
    const [hours = "00", minutes = "00"] = time.split(":");
    return `${hours.padStart(2, "0")}:${minutes.padStart(2, "0")}`;
  };

  getSlaUnitLabel = (unit) => {
    if (unit === "ชั่วโมง") return t("sla_unit_hour");
    if (unit === "วันทำการ") return t("sla_unit_business_day");
    return unit || t("sla_unit_hour");
  };

  buildSchedule = (technicians, workOrders, scheduleDays, modelNameByUid = new Map()) => {
    const techMap = new Map();
    const mappedTechnicians = technicians.map((tech, index) => {
      const name = this.getTechnicianName(tech);
      const initials = this.getTechnicianInitials(name);
      // ทักษะ = รุ่นเครื่องพิมพ์ที่ชำนาญ (item เป็น uid ของ warehouse/models) แปลงเป็นชื่อรุ่นก่อนแสดง
      // list API ไม่ได้เรียง technician_skill มาให้ จึงเรียงตาม sequence เอง ตัวแรกถือเป็นทักษะหลัก (ใช้จัดกลุ่มตอนเรียงตามทักษะ)
      // เดิมโชว์แค่ level ("ชำนาญ") ซึ่งบอกไม่ได้ว่าถนัดรุ่นไหน
      const skills = (Array.isArray(tech.technician_skill) ? tech.technician_skill : [])
        .filter((skill) => skill && skill.is_active !== false)
        .sort((a, b) => (Number(a.sequence) || 0) - (Number(b.sequence) || 0));
      const skillNames = skills
        .map((skill) => modelNameByUid.get(skill.item) || String(skill.item || "").trim())
        .filter(Boolean);
      const skillLabels = skillNames.join(", ");
      const primarySkill = skillNames[0] || "";

      const mappedTech = {
        uid: tech.uid,
        technician_code: tech.technician_code,
        name,
        filter_label: this.getTechnicianFilterLabel(tech),
        skills: skillLabels || t("no_skill"),
        primarySkill,
        skillNames,
        // ประวัติจาก visit ที่ทำเสร็จแล้ว - AI แนะนำใช้ให้คะแนนประสบการณ์/ความคุ้นเคยลูกค้า/คะแนนจากลูกค้า
        history: { doneVisits: 0, ratingSum: 0, ratingCount: 0, models: {}, customers: {} },
        initials,
        bg: TECHNICIAN_COLORS[index % TECHNICIAN_COLORS.length],
        jobsCount: `0 ${t("jobs")}`,
        utilBg: "#e0ebff",
        utilText: "0%",
        utilColor: "#0d6efd",
        schedule: {},
        is_active: tech.is_active,
        // เก็บไว้ทำฟิลเตอร์ "ลูกน้องของฉัน" - เป็น uid ของ user ที่ถูกเลือกเป็นผู้บังคับบัญชาของช่างคนนี้
        supervisor_id: tech.supervisor_id || "",
        // ปิดใช้งาน = จัดลำดับไปท้ายสุดเสมอ (sortTechnicians) และไม่เข้าเกณฑ์ AI แนะนำ - ไม่ล็อกการมอบหมายงานในตารางอีกต่อไป
        // (พื้นหลังย้อมสีต่อวันจาก /holidays/effective ทำหน้าที่บอก "ลา" แทน badge เดิมที่ผูกกับ is_active เท่านั้น)
        isLeave: !tech.is_active,
      };

      techMap.set(tech.uid, mappedTech);
      return mappedTech;
    });

    const unassignedJobs = [];

    workOrders.forEach((workOrder) => {
      const customerName = workOrder.customer?.full_name_th || t("customer");
      const title = workOrder.asset?.part?.name || t("work_order");

      const priority = workOrder.priority?.name_th || t("priority");
      // รุ่น/ยี่ห้อ/ซีรีส์ของเครื่องในใบงาน - ใช้เทียบกับทักษะช่าง (ทักษะเก็บเป็นชื่อรุ่นจาก warehouse/models)
      const modelName = workOrder.asset?.part?.model_name || "";
      const brandName = workOrder.asset?.part?.brand_name || "";
      const serieName = workOrder.asset?.part?.serie_name || "";
      const customerUid = workOrder.customer?.uid || "";
      const slaHours = this.getSlaHours(workOrder.priority);
      const slaUnit = this.getSlaUnitLabel(workOrder.priority?.sla_response_time_start_unit);
      const sla = workOrder.priority?.sla_response_time_start
        ? `${t("sla")}: ${workOrder.priority.sla_response_time_start} ${slaUnit}`
        : `${t("sla")}: -`;

      (workOrder.visits || []).forEach((visit) => {
        const hasTechnician = Array.isArray(visit.visits_technicians) && visit.visits_technicians.length > 0;
        const hasSchedule = Boolean(visit.start_date || visit.end_date);
        const dateKey = this.formatDateKey(visit.start_date);
        const time = this.formatTime(visit.start_date);
        const job = {
          workOrderUid: workOrder.uid,
          visitUid: visit.uid,
          id: workOrder.wo_number || workOrder.wr_number,
          priority,
          priorityBg: workOrder.priority?.background_color || "#fff0e0",
          priorityColor: workOrder.priority?.font_color || "#000000",
          // การ์ดงานบนตารางแยกสี CM/PM จากประเภทงานจริง ไม่ใช่ระดับความสำคัญอีกต่อไป
          isPm: Boolean(workOrder.inspection_plan_id),
          title,
          customer: customerName,
          sla,
          distance: workOrder.distance_text || (workOrder.distance_km ? `${workOrder.distance_km} km` : "-"),
          slaColor: workOrder.priority?.font_color || undefined,
          status: visit.status,
          hasSchedule,
          time,
          start_date: visit.start_date,
          end_date: visit.end_date,
          fullDate: dateKey,
          modelName,
          brandName,
          serieName,
          customerUid,
          slaHours,
          createdAt: workOrder.created_at || "",
        };

        // Unassigned Jobs = visit ที่ยังไม่มีช่างถูก assign ไม่ว่าจะมีวันที่/ช่วงกำหนดแล้วหรือยังไม่มีก็ตาม
        if (!hasTechnician) {
          unassignedJobs.push(job);
          return;
        }

        // สะสมประวัติให้ช่างทุกคนที่ทำ visit นี้เสร็จแล้ว (ไม่สนว่าอยู่ในช่วงที่ตารางแสดงหรือไม่)
        if (COMPLETED_VISIT_STATUSES.includes(String(visit.status || "").toLowerCase())) {
          visit.visits_technicians.forEach((visitTech) => {
            const history = techMap.get(visitTech?.technician?.uid)?.history;
            if (!history) return;
            history.doneVisits += 1;
            const modelKey = this.normalizeText(modelName);
            if (modelKey) history.models[modelKey] = (history.models[modelKey] || 0) + 1;
            if (customerUid) history.customers[customerUid] = (history.customers[customerUid] || 0) + 1;
            const rating = Number(visit.customer_rating);
            if (rating > 0) {
              history.ratingSum += rating;
              history.ratingCount += 1;
            }
          });
        }

        if (!hasSchedule) return;

        visit.visits_technicians.forEach((visitTech) => {
          const techUid = visitTech?.technician?.uid;
          const tech = techMap.get(techUid);
          if (!tech) return;
          const scheduleItem = {
            ...job,
            technicianUid: techUid,
            technicianName: tech.name,
          };
          tech.schedule[dateKey] = tech.schedule[dateKey] || [];
          tech.schedule[dateKey].push(scheduleItem);
        });
      });
    });

    const visibleDateKeys = (scheduleDays || []).map((day) => day.fullDate);

    mappedTechnicians.forEach((tech) => {
      Object.assign(tech, this.getVisibleStats(tech, visibleDateKeys));
    });

    // ช่างที่ปิดใช้งานไม่ต้องขึ้นแถวบนบอร์ด ยกเว้นยังมีงานค้างอยู่ในช่วงที่แสดง
    // (backend กันไม่ให้ปิดช่างที่ยังมีงานค้างอยู่แล้ว เคสนี้จึงเหลือเฉพาะข้อมูลเก่าก่อนเพิ่มเงื่อนไข)
    const visibleTechnicians = mappedTechnicians.filter(
      (tech) => tech.is_active !== false || visibleDateKeys.some((dateKey) => (tech.schedule[dateKey] || []).length > 0)
    );

    return { mappedTechnicians: visibleTechnicians, unassignedJobs };
  };

  // ช่องวัน x ช่างหนึ่งช่อง - รวมวันหยุด(ย้อมพื้นหลัง)/กิจกรรม(teal)/งาน(สูงสุด 2 ที่เหลือยุบเป็น +N)/ปุ่มวางงานที่นี่(มีเสมอ)
  // ขนาดคงที่ทุกช่อง (DAY_CELL_HEIGHT) เนื้อหาที่ล้นเลื่อนดูได้ในช่องแทนการดันแถวให้สูงขึ้น
  renderDayCell = (tech, day, dIdx, isDraftTab) => {
    const { dragOverKey } = this.state;
    const jobs = tech.schedule[day.fullDate] || [];
    const cellKey = `${tech.uid}_${day.fullDate}`;
    const isDragOver = dragOverKey === cellKey;
    const holiday = this.getTechHoliday(tech.uid, day.fullDate);
    const isTechnicianHoliday = holiday?.source === "technician";
    const isCompanyHoliday = Boolean(holiday) && !isTechnicianHoliday;
    const activities = this.getTechActivities(tech.uid, day.fullDate);
    const visibleJobs = jobs.slice(0, MAX_JOBS_PER_CELL);
    const remainingJobs = jobs.length - visibleJobs.length;
    const tintClass = isTechnicianHoliday ? "bg-danger-light" : isCompanyHoliday ? "bg-secondary-light" : "bg-white";

    return (
      <td
        key={dIdx}
        className={`border-end p-2 align-top ${isDragOver ? "bg-primary-light" : tintClass}`}
        style={{
          width: DAY_COLUMN_WIDTH,
          minWidth: DAY_COLUMN_WIDTH,
          height: DAY_CELL_HEIGHT,
          maxHeight: DAY_CELL_HEIGHT,
          overflowY: "auto",
          ...(isDragOver ? { boxShadow: "inset 0 0 0 2px #0d6efd" } : {}),
        }}
        // แท็บแบบร่างก็รับลากวาง แต่ handleDrop จะแยกไปแก้แบบร่างแทนข้อมูลจริง
        onDragOver={(event) => this.handleDragOver(event, day.fullDate)}
        onDragEnter={() => this.handleDragEnterCell(cellKey, day.fullDate)}
        onDragLeave={(event) => this.handleDragLeaveCell(event, cellKey)}
        onDrop={(event) => this.handleDrop(event, tech.uid, day.fullDate)}
      >
        <div className="d-flex flex-column gap-2 h-100">
          {holiday && (
            <div
              className={`text-10 fw-bold text-truncate ${isTechnicianHoliday ? "text-danger" : "text-secondary"}`}
              title={holiday.name || (isTechnicianHoliday ? t("hd_technician_holiday") : t("hd_company_holiday"))}
            >
              {holiday.name || (isTechnicianHoliday ? t("hd_technician_holiday") : t("hd_company_holiday"))}
            </div>
          )}

          {activities.map((activity, aIdx) => {
            const timeLabel = this.getActivityTimeLabel(activity);
            const objectiveName = activity.objective?.name || t("activity_legend");
            return (
              <div
                key={activity.uid || aIdx}
                className="bg-teal-light text-teal text-start p-2 rounded-2 text-10 text-truncate cursor-pointer"
                title={`${timeLabel ? `${timeLabel} - ` : ""}${objectiveName}`}
                onClick={(event) => {
                  event.stopPropagation();
                  this.openActivityModal(activity);
                }}
              >
                {timeLabel ? `${timeLabel} - ` : ""}
                {objectiveName}
              </div>
            );
          })}

          {visibleJobs.map((job, jIdx) => (
            <div
              key={jIdx}
              // แท็บแบบร่าง: ลากได้เฉพาะการ์ดที่ AI ลงให้ (งานจริงต้องย้ายที่แท็บปัจจุบันเพราะต้องบันทึกลงระบบ)
              draggable={can("wo.update") && (job.isAiDraft ? true : !isDraftTab && this.isVisitOpenStatus(job.status))}
              onDragStart={(event) => this.handleDragStart(event, job)}
              // การ์ดที่ AI ลงให้: กรอบกะพริบ (ai-draft-card ใน style.css) กดดูเหตุผล/เอาออกจากแบบร่าง
              // สี CM/PM คงที่ตามประเภทงาน (isPm) ไม่ผูกกับระดับความสำคัญอีกต่อไป
              className={`text-start p-2 rounded-2 shadow-sm position-relative cursor-pointer ${job.isAiDraft ? "ai-draft-card" : ""} ${
                job.isPm ? "bg-primary text-white" : "bg-orange text-white"
              }`}
              title={job.isAiDraft ? (job.aiReasons || []).join("\n") : undefined}
              onClick={() => (job.isAiDraft ? this.showDraftAssignment(job) : !isDraftTab && this.openWorkOrderPage(job))}
            >
              {job.isAiDraft && (
                <span className={`badge text-white text-10 px-2 py-1 position-absolute ${job.movedByUser ? "bg-secondary" : "bg-purple"}`} style={{ top: -8, right: -6 }}>
                  <span className="icon me-1">{job.movedByUser ? "" : ""}</span>
                  {job.movedByUser ? t("ai_draft_moved_badge") : `AI ${job.aiScore}`}
                </span>
              )}
              <div className="fw-bold text-12 text-truncate">
                {job.time} - {job.title}
              </div>
              <div className="text-10 text-truncate opacity-75">{job.customer}</div>
            </div>
          ))}

          {remainingJobs > 0 && (
            <div
              className="text-10 text-secondary border rounded-pill text-center px-2 py-1"
              style={{ borderStyle: "dashed" }}
              title={jobs
                .slice(MAX_JOBS_PER_CELL)
                .map((job) => `${job.time} ${job.id} - ${job.title}`)
                .join("\n")}
            >
              {t("jobs_more_count").replace("{n}", remainingJobs)}
            </div>
          )}

          {/* ทุกช่องมีปุ่ม "วางงานที่นี่" เสมอ แม้มีวันหยุด/กิจกรรม/งานอยู่แล้ว - ไม่ล็อกการมอบหมายงาน */}
          <div
            className={`border rounded-3 text-center text-10 py-1 mt-auto ${isDragOver ? "border-primary text-primary fw-bold" : "text-secondary"}`}
            style={{ borderStyle: "dashed", backgroundColor: isDragOver ? "#e7f1ff" : "#fcfcfc" }}
          >
            {t("drop_job_here")}
          </div>
        </div>
      </td>
    );
  };

  renderDraftDetailModal = () => {
    const { draftDetail } = this.state;
    const job = draftDetail;
    const technician = job ? (this.state.allTechnicians || []).find((item) => item.uid === job.technicianUid) : null;
    const score = Math.max(0, Math.min(100, Number(job?.aiScore) || 0));
    const scoreColor = score >= 60 ? "success" : score >= 30 ? "warning" : "danger";
    // เหตุผลเป็น "หัวข้อ: รายละเอียด" - แยกโชว์ให้อ่านง่าย ข้อที่เป็นด้านลบ (ไม่มีทักษะ/งานค้าง) ใช้ไอคอนคนละแบบ
    const reasons = (job?.aiReasons || []).map((reason) => {
      const [label, ...rest] = String(reason).split(":");
      const negative = reason.startsWith(t("ai_reason_skill_none")) || reason.startsWith(t("ai_reason_workload"));
      const neutral = reason.startsWith(t("ai_reason_no_model_info")) || reason.startsWith(t("ai_reason_moved_by_user"));
      return { label: label.trim(), detail: rest.join(":").trim(), icon: negative ? "\uf071" : neutral ? "\uf05a" : "\uf00c", color: negative ? "text-warning" : neutral ? "text-secondary" : "text-success" };
    });

    return (
      <Modal size="md" show={Boolean(job)} onHide={this.closeDraftDetail} centered contentClassName="border-0 rounded-4 overflow-hidden shadow-lg bg-light">
        <Modal.Header className="bg-white border-bottom px-4 py-3 d-flex justify-content-between align-items-center" closeButton>
          <h5 className="mb-0 d-flex align-items-center">
            <span className="icon text-purple me-2">{"\uf0d0"}</span> {t("ai_draft_detail_title")}
          </h5>
        </Modal.Header>
        {job && (
          <Modal.Body className="p-4">
            {/* งาน */}
            <div className="bg-white rounded-3 border p-3 mb-3">
              <div className="d-flex justify-content-between align-items-center mb-1">
                <span className="text-primary fw-bold text-14">{job.id}</span>
                <span className="badge rounded-pill fw-bold text-10 px-2 py-1" style={{ backgroundColor: job.priorityBg, color: job.priorityColor }}>
                  {job.priority}
                </span>
              </div>
              <div className="fw-bold text-dark text-16">{job.title}</div>
              <div className="text-secondary text-14">{job.customer}</div>
            </div>

            {/* ช่าง + กำหนดการ */}
            <div className="row g-3 mb-3">
              <div className="col-6">
                <div className="bg-white rounded-3 border p-3 h-100">
                  <div className="text-secondary text-12 mb-2">{t("technician")}</div>
                  <div className="d-flex align-items-center">
                    <div className="rounded-circle text-white d-flex align-items-center justify-content-center fw-bold text-14 flex-shrink-0 me-2" style={{ width: 36, height: 36, backgroundColor: technician?.bg || "#6c757d" }}>
                      {technician?.initials || "--"}
                    </div>
                    <div className="overflow-hidden">
                      <div className="fw-bold text-dark text-14 text-truncate">{job.technicianName}</div>
                      <div className="text-secondary text-12 text-truncate">{technician?.skills || ""}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="bg-white rounded-3 border p-3 h-100">
                  <div className="text-secondary text-12 mb-2">{t("ai_draft_schedule")}</div>
                  <div className="fw-bold text-dark text-14 d-flex align-items-center mb-1">
                    <span className="icon me-2 text-secondary">{"\uf073"}</span> {job.fullDate ? format_date(job.fullDate, "dd/mm/yyyy", "th") : "-"}
                  </div>
                  <div className="fw-bold text-dark text-14 d-flex align-items-center">
                    <span className="icon me-2 text-secondary">{"\uf017"}</span> {job.timeSlot || "-"}
                  </div>
                </div>
              </div>
            </div>

            {/* คะแนน */}
            <div className="bg-white rounded-3 border p-3 mb-3">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <span className="text-secondary text-12">{t("ai_match_score")}</span>
                <span className={`badge ${job.movedByUser ? "bg-secondary" : `bg-${scoreColor}`} text-white rounded-pill px-2`}>
                  {job.movedByUser ? t("ai_draft_moved_badge") : `${score} / 100`}
                </span>
              </div>
              <div className="progress" style={{ height: 8 }}>
                <div className={`progress-bar bg-${scoreColor}`} role="progressbar" style={{ width: `${score}%` }} aria-valuenow={score} aria-valuemin="0" aria-valuemax="100" />
              </div>
            </div>

            {/* เหตุผล */}
            <div className="bg-white rounded-3 border p-3">
              <div className="text-secondary text-12 mb-2">{t("ai_draft_reasons")}</div>
              <div className="d-flex flex-column gap-2">
                {reasons.map((reason, index) => (
                  <div key={index} className="d-flex align-items-start text-14">
                    <span className={`icon me-2 wpx-15 text-center flex-shrink-0 ${reason.color}`}>{reason.icon}</span>
                    <div>
                      <span className="text-dark">{reason.label}</span>
                      {reason.detail && <span className="text-secondary"> {reason.detail}</span>}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Modal.Body>
        )}
        <Modal.Footer className="bg-white border-top px-4 py-3 d-flex justify-content-between align-items-center">
          <button type="button" className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" onClick={this.closeDraftDetail}>
            {t("close")}
          </button>
          <button type="button" className="btn btn-outline-danger px-4 py-2 rounded-3 fw-bold" onClick={() => this.removeDraftAssignment(job)}>
            <span className="icon me-2">{"\uf1f8"}</span> {t("ai_draft_remove")}
          </button>
        </Modal.Footer>
      </Modal>
    );
  };

  render() {
    const { scheduleDays, unassignedJobs, showAllUnassigned, weekStartDate, hoveredUnassignedKey, rangeMode, filterTechnicianUid, sortMode, visibleTechCount } = this.state;
    const displayedTechnicians = this.getDisplayedTechnicians();
    const shownTechnicians = displayedTechnicians.slice(0, visibleTechCount);
    const hiddenTechCount = displayedTechnicians.length - shownTechnicians.length;
    const { boardTab, aiDraft, aiGenerating, aiGeneratingStep } = this.state;
    const isDraftTab = this.isDraftTab();
    // มุมมองแบบร่าง: ส่วน "งานที่ยังไม่มอบหมาย" เหลือเฉพาะงานที่ AI จัดให้ไม่ได้ (ที่จัดได้ไปอยู่บนตารางแล้ว)
    const pendingJobs = isDraftTab ? aiDraft.unmatched : unassignedJobs;

    return (
        <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
            <NavbarAdmin />
            {/* ดู/แก้ไข/ลบกิจกรรมช่างจาก chip สีทีล - บันทึก/ลบสำเร็จแล้วโหลดตารางใหม่ (ไม่รีโหลดทั้งหน้า) */}
            <ActivityModal
              show={this.state.activityModalOpen}
              activity={this.state.activityModalActivity}
              technicians={this.state.rawTechnicians}
              objectives={this.state.activityObjectives}
              alertUrl=""
              onClose={this.closeActivityModal}
              onSaved={this.fetchSchedulingData}
            />
            {/* หน้าโหลดของ AI แนะนำ - บังทั้งหน้าประมาณ 5 วินาที พร้อมไล่ข้อความขั้นตอน */}
            {aiGenerating && (
                <div
                    className="position-fixed top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center text-center px-3"
                    style={{ zIndex: 2000, backgroundColor: "rgba(255,255,255,0.88)", backdropFilter: "blur(2px)" }}
                >
                    <div className="spinner-border text-primary mb-3" role="status" style={{ width: 48, height: 48 }} />
                    <div className="fw-bold text-dark text-18 mb-1">
                        <span className="icon me-2">{"\uf0d0"}</span> {t("ai_generating_title")}
                    </div>
                    <div className="text-secondary text-14 mb-3">{t("ai_generating_desc")}</div>
                    <div className="text-start">
                        {AI_GENERATING_STEPS.map((stepKey, index) => (
                            <div key={stepKey} className={`text-14 mb-1 d-flex align-items-center ${index < aiGeneratingStep ? "text-success" : index === aiGeneratingStep ? "text-primary fw-bold" : "text-secondary opacity-50"}`}>
                                <span className="icon me-2 wpx-15 text-center">{index < aiGeneratingStep ? "\uf00c" : index === aiGeneratingStep ? "\uf110" : "\uf111"}</span>
                                {t(stepKey)}
                            </div>
                        ))}
                    </div>
                </div>
            )}
            <div className="body p-4 mt-3">
                {/* Header Section */}
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 gap-3">
                    <div>
                        <h3 className="fw-bold mb-1">{t("scheduling")}</h3>
                        <div className="text-secondary">{t("manage_tech_schedules")}</div>
                    </div>
                    {/* แถบเครื่องมือ: คุมความสูงทุกปุ่มให้เท่ากันและห้ามข้อความตัดบรรทัด
                        (ก่อนหน้านี้ "Aug 17 - Aug 23" และ "วันนี้" ถูกบีบจนขึ้นบรรทัดใหม่)
                        ms-auto = ชิดขวาเสมอ แม้จอแคบจนแถบตกลงมาอยู่บรรทัดใต้หัวข้อ (justify-content-between ของแถวแม่จะดันไปชิดซ้าย) */}
                    <div className="d-flex gap-2 align-items-center flex-nowrap justify-content-end ms-auto" style={{ overflowX: "auto", flex: "0 0 auto", maxWidth: "100%" }}>
                        <div className="d-flex align-items-center bg-white border rounded-3 shadow-sm overflow-hidden" style={TOOLBAR_CONTROL}>
                            <button
                                className="btn btn-white border-0 text-secondary h-100 d-flex align-items-center justify-content-center px-2"
                                onClick={() => this.changeWeek(-1)}
                                title={t("previous")}
                            >
                                <span className="icon text-12">{"\uf053"}</span>
                            </button>
                            <div className="fw-bold text-dark text-14 text-nowrap text-center px-2" style={{ minWidth: 172 }}>
                                {this.formatWeekRange(weekStartDate)}
                            </div>
                            <button
                                className="btn btn-white border-0 text-secondary h-100 d-flex align-items-center justify-content-center px-2"
                                onClick={() => this.changeWeek(1)}
                                title={t("next")}
                            >
                                <span className="icon text-12">{"\uf054"}</span>
                            </button>
                        </div>

                        {/* ฟิลเตอร์ช่วงเวลา สัปดาห์ / เดือน (ISS-022) - โหมด "วันนี้" ถูกตัดออกตามที่ลูกค้าขอ
                            ใช้สไตล์ pill เดียวกับแท็บสลับมุมมองในหน้าใบงาน (รายการ/คัมบังบอร์ด/ปฏิทิน) */}
                        <div className="btn-group bg-white p-1 rounded-3 shadow-sm border" role="group" style={TOOLBAR_CONTROL}>
                            {[
                                { key: "week", label: t("range_week"), icon: "\uf784" },
                                { key: "month", label: t("range_month"), icon: "\uf073" },
                            ].map((option) => (
                                <button
                                    key={option.key}
                                    type="button"
                                    className={`btn btn-sm rounded-2 px-3 fw-bold text-nowrap d-flex align-items-center border-0 ${
                                        rangeMode === option.key ? "btn-primary" : "btn-white text-secondary bg-transparent"
                                    }`}
                                    onClick={() => this.changeRangeMode(option.key)}
                                >
                                    <span className="icon me-2">{option.icon}</span> {option.label}
                                </button>
                            ))}
                        </div>

                        {/* ฟิลเตอร์ช่าง - ทั้งหมด หรือเลือกดูทีละคน
                            ใช้ <Select> ของ CustomComponent เหมือนหน้าอื่นทั้งระบบ (ค้นหาในลิสต์ได้) */}
                        <div style={{ ...TOOLBAR_CONTROL, minWidth: 210, maxWidth: 250 }}>
                            <Select
                                className="form-control h-100 w-100 rounded-3 text-dark bg-white d-flex align-items-center"
                                sort={false}
                                options={this.getTechnicianFilterOptions()}
                                value={filterTechnicianUid || "all"}
                                onChange={(value) => this.changeTechnicianFilter(value === "all" ? "" : value)}
                                placeholder={t("filter_by_technician")}
                                dropdownAutoWidth
                            />
                        </div>

                        {/* วิธีเรียงแถวช่าง - sort={false} เพราะลำดับตัวเลือกมีความหมาย (ค่าเริ่มต้นอยู่บนสุด) */}
                        <div style={{ ...TOOLBAR_CONTROL, minWidth: 200, maxWidth: 260 }}>
                            <Select
                                sort={false}
                                className="form-control h-100 w-100 rounded-3 text-dark bg-white d-flex align-items-center"
                                options={this.getSortOptions()}
                                value={sortMode}
                                onChange={this.changeSortMode}
                                placeholder={t("sort_technicians")}
                                dropdownAutoWidth
                            />
                        </div>

                        {/* ปุ่มกระโดดกลับมาที่ช่วงเวลาปัจจุบัน - ใช้ไอคอนอย่างเดียว
                            เพราะคำว่า "วันนี้" ซ้ำกับปุ่มเลือกช่วงเวลาด้านซ้าย และกินความกว้างจนแถวตัดบรรทัด */}
                        <button
                            className="btn btn-white bg-white border shadow-sm fw-bold rounded-3 text-dark d-flex align-items-center justify-content-center"
                            style={{ ...TOOLBAR_CONTROL, width: 40 }}
                            onClick={this.showCurrentWeek}
                            title={t("back_to_today")}
                            aria-label={t("back_to_today")}
                        >
                            <span className="icon text-secondary text-14">{"\uf073"}</span>
                        </button>

                        {/* AI แนะนำ - จัดงานที่ยังไม่มอบหมายเป็นแบบร่างบนแท็บ "แบบร่าง AI" ยังไม่บันทึกจนกว่าจะกดยืนยัน */}
                        <button
                            type="button"
                            className="btn btn-primary fw-bold px-3 rounded-3 shadow-sm d-flex align-items-center text-nowrap"
                            style={TOOLBAR_CONTROL}
                            onClick={this.generateAiDraft}
                            // มีแบบร่างค้างอยู่ห้ามสร้างซ้อน ต้องล้างแบบร่างก่อน (ปุ่มล้างอยู่บนแถบสรุปของแท็บแบบร่าง)
                            disabled={Boolean(aiDraft) || aiGenerating}
                            title={aiDraft ? t("ai_draft_clear_first") : t("ai_suggestions_desc")}
                        >
                            <span className="icon me-2">{"\uf0d0"}</span> {t("ai_suggest")}
                        </button>
                    </div>
                </div>

                {/* Unassigned Jobs Section */}
                <div ref={this.setUnassignedRef} className="bg-white rounded-4 shadow-sm p-3 mb-4 border border-light" style={{ position: "sticky", top: NAVBAR_HEIGHT, zIndex: 10, backgroundColor: "#fff" }}>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h6 className="fw-bold mb-0 d-flex align-items-center text-dark">
                            <span className="icon text-warning me-2 text-18">{"\uf187"}</span> {isDraftTab ? t("ai_draft_unmatched_title") : t("unassigned_jobs")}
                            <span className="badge bg-warning text-white rounded-pill ms-2 px-2">{pendingJobs.length}</span>
                        </h6>
                        <button type="button" className="btn btn-link p-0 text-primary text-decoration-none fw-bold text-14" onClick={this.toggleUnassignedView}>
                            {showAllUnassigned ? t("hide_all") : t("view_all")}
                        </button>
                    </div>

                    <div
                        ref={this.setUnassignedListRef}
                        className="d-flex gap-3 overflow-auto pb-2"
                        style={{
                            whiteSpace: showAllUnassigned ? "normal" : "nowrap",
                            flexWrap: showAllUnassigned ? "wrap" : "nowrap",
                            overflowY: showAllUnassigned ? "auto" : undefined,
                        }}
                    >
                        {pendingJobs.map((job, idx) => {
                            const jobKey = this.getUnassignedJobKey(job);
                            const isEditable = this.isVisitOpenStatus(job.status);
                            const isActive = hoveredUnassignedKey === jobKey;

                            return (
                            <div
                                key={idx}
                                // แท็บแบบร่าง: ลากงานที่ AI จัดไม่ได้ไปลงตารางได้ (กลายเป็นงานในแบบร่าง) แต่กดแก้ไขไม่ได้
                                draggable={isEditable && can("wo.update")}
                                onClick={() => !isDraftTab && this.openWorkOrderPage(job)}
                                onDragStart={(event) => this.handleDragStart(event, job)}
                                onMouseEnter={() => this.handleUnassignedMouseEnter(jobKey)}
                                onMouseLeave={() => this.handleUnassignedMouseLeave(jobKey)}
                                className="rounded-3 shadow-none p-3"
                                style={{
                                    cursor: "pointer",
                                    minWidth: "260px",
                                    borderStyle: "dashed",
                                    borderWidth: "2px",
                                    borderColor: isActive ? "#0d6efd" : "#dee2e6",
                                    transition: "border-color 0.15s ease",
                                }}
                            >
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <span className="text-primary fw-bold text-12">{job.id}</span>
                                    <span className="badge rounded-pill fw-bold text-10 px-2 py-1" style={{ backgroundColor: job.priorityBg, color: job.priorityColor }}>
                                        {job.priority}
                                    </span>
                                </div>
                                <div className="fw-bold text-dark text-14 text-truncate">{job.title}</div>
                                <div className="text-secondary text-12 mb-2 text-truncate">{job.customer}</div>
                                {job.unmatchedReason && (
                                    <div className="text-danger text-12 mb-2 d-flex align-items-center">
                                        <span className="icon me-1">{"\uf071"}</span> {job.unmatchedReason}
                                    </div>
                                )}
                                <div className="d-flex justify-content-between text-12 text-secondary">
                                    <div className="d-flex align-items-center" style={{ color: job.slaColor || "inherit" }}>
                                        <span className="icon me-1">{"\uf017"}</span> {job.sla}
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <span className="icon me-1">{"\uf041"}</span> {job.distance}
                                    </div>
                                </div>
                            </div>
                            );
                        })}
                    </div>
                </div>

                {/* รายละเอียดการ์ดที่ AI ลงให้ในแบบร่าง */}
                {this.renderDraftDetailModal()}

                {/* Schedule Grid Section */}
                <div className="bg-white rounded-4 shadow-sm mb-4 border border-light overflow-hidden">
                    {/* แท็บมุมมอง: ปัจจุบัน / แบบร่าง AI - โผล่เฉพาะตอนมีแบบร่าง (กด AI แนะนำ) หายไปเมื่อล้างแบบร่าง */}
                    {aiDraft && (
                    <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 px-3 py-2 border-bottom">
                        <div className="btn-group bg-light p-1 rounded-3 border" role="group" style={TOOLBAR_CONTROL}>
                            {[
                                { key: BOARD_TAB_CURRENT, label: t("current"), icon: "\uf00b" },
                                { key: BOARD_TAB_AI_DRAFT, label: t("ai_draft_tab"), icon: "\uf0d0", count: aiDraft?.assignments?.length },
                            ].map((tab) => (
                                <button
                                    key={tab.key}
                                    type="button"
                                    className={`btn btn-sm rounded-2 px-3 fw-bold text-nowrap d-flex align-items-center border-0 ${
                                        boardTab === tab.key ? "btn-primary" : "btn-white text-secondary bg-transparent"
                                    }`}
                                    onClick={() => this.changeBoardTab(tab.key)}
                                >
                                    <span className="icon me-2">{tab.icon}</span> {tab.label}
                                    {typeof tab.count === "number" && (
                                        <span className={`badge rounded-pill ms-2 px-2 ${boardTab === tab.key ? "bg-white text-primary" : "bg-primary text-white"}`}>{tab.count}</span>
                                    )}
                                </button>
                            ))}
                        </div>

                        {isDraftTab && (
                            <div className="d-flex flex-wrap align-items-center gap-2 ms-auto">
                                <div className="text-secondary text-12 text-end lh-sm">
                                    <div>
                                        <span className="fw-bold text-dark">{aiDraft.assignments.length}</span> {t("ai_draft_assigned_jobs")}
                                        {aiDraft.unmatched.length > 0 && (
                                            <>
                                                {" · "}
                                                <span className="fw-bold text-danger">{aiDraft.unmatched.length}</span> {t("ai_draft_unmatched_jobs")}
                                            </>
                                        )}
                                        {" · "}
                                        {t("ai_draft_start_from")} {format_date(aiDraft.startDate, "dd/mm/yyyy", "th")}
                                    </div>
                                    <div>{t("ai_draft_generated_desc")}</div>
                                </div>
                                <button type="button" className="btn btn-white border rounded-3 fw-bold text-14 text-nowrap" style={TOOLBAR_CONTROL} onClick={this.discardAiDraft}>
                                    <span className="icon me-2">{"\uf1f8"}</span> {t("ai_draft_discard")}
                                </button>
                                {can("wo.update") && (
                                  <button type="button" className="btn btn-success rounded-3 fw-bold text-14 text-nowrap shadow-sm" style={TOOLBAR_CONTROL} onClick={this.confirmAiDraft}>
                                      <span className="icon me-2">{"\uf00c"}</span> {t("ai_draft_confirm_button")}
                                  </button>
                                )}
                            </div>
                        )}
                    </div>
                    )}

                    <div className="table-responsive" ref={this.setGridScrollRef} style={{ overflowY: "auto" }}>
                        <table
                            className="table table-bordered mb-0 text-center align-middle"
                            style={{
                                tableLayout: "fixed",
                                minWidth: TECH_COLUMN_WIDTH + scheduleDays.length * DAY_COLUMN_WIDTH,
                            }}
                        >
                            <thead>
                                <tr>
                                    <th
                                        className="bg-white py-3 text-start ps-4 border-0 border-bottom border-end"
                                        style={{ ...STICKY_TECH_COLUMN, top: 0, zIndex: 4 }}
                                    >
                                        {t("technician")}
                                    </th>
                                    {scheduleDays.map((day, idx) => (
                                        <th
                                            key={idx}
                                            className={`py-3 border-0 border-bottom border-end ${day.isToday ? "bg-primary-light" : "bg-white"}`}
                                            style={{ ...STICKY_DAY_HEADER, width: DAY_COLUMN_WIDTH, minWidth: DAY_COLUMN_WIDTH }}
                                        >
                                            <div className={`fw-bold text-14 ${day.isToday ? "text-primary" : "text-dark"}`}>
                                                {day.day} {day.date}
                                            </div>
                                            {day.sub && <div className={`text-12 fw-normal ${day.isToday ? "text-primary" : "text-secondary"}`}>{day.sub}</div>}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {shownTechnicians.map((tech) => (
                                    <tr key={tech.uid}>
                                        <td className="text-start ps-3 py-3 border-end bg-white" style={STICKY_TECH_COLUMN}>
                                            <div className="d-flex align-items-center mb-2">
                                                <div
                                                    className="wpx-40 hpx-40 rounded-circle text-white d-flex align-items-center justify-content-center fw-bold text-14 flex-shrink-0 me-3"
                                                    style={{ backgroundColor: tech.bg }}
                                                >
                                                    {tech.initials}
                                                </div>
                                                <div className="overflow-hidden">
                                                    <div className="fw-bold text-dark text-14 text-truncate">{tech.name}</div>
                                                    <div className="text-secondary text-10 text-wrap lh-sm mt-1">{tech.skills}</div>
                                                </div>
                                            </div>
                                            <div className="d-flex gap-2">
                                                {/* แท็บแบบร่าง: จำนวนงานที่ AI ลงให้ช่างคนนี้ (แถวเรียงตามเลขนี้ มาก -> น้อย) */}
                                                {isDraftTab && tech.draftCount > 0 && (
                                                    <span className="badge bg-purple text-white text-10 px-2 py-1">
                                                        <span className="icon me-1">{"\uf0d0"}</span>AI {tech.draftCount}
                                                    </span>
                                                )}
                                                <span className="badge bg-success-light text-success text-10 px-2 py-1">{tech.jobsCount}</span>
                                                <span className="badge text-10 px-2 py-1" style={{ backgroundColor: tech.utilBg, color: tech.utilColor }}>
                                                    {tech.utilText}
                                                </span>
                                            </div>
                                        </td>

                                        {/* ทุกช่องขนาดคงที่และมีปุ่ม "วางงานที่นี่" เสมอ (ดูรายละเอียดใน renderDayCell) -
                                            วันหยุด/ลาของช่างคนนี้ไม่ล็อกทั้งแถวอีกต่อไป แสดงเป็นพื้นหลังย้อมสีต่อวันแทน */}
                                        {scheduleDays.map((day, dIdx) => this.renderDayCell(tech, day, dIdx, isDraftTab))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* แถบท้ายตาราง - บอกว่าเปิดดูกี่คนจากทั้งหมด และกดเปิดเพิ่มทีละชุด / ทั้งหมด */}
                    {displayedTechnicians.length > 0 && (
                        <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 px-3 py-2 border-top bg-white">
                            <div className="text-secondary text-14">
                                {t("showing")} {shownTechnicians.length} {t("of")} {displayedTechnicians.length} {t("technician_count_unit")}
                            </div>
                            {hiddenTechCount > 0 && (
                                <div className="d-flex gap-2">
                                    <button type="button" className="btn btn-white border rounded-3 fw-bold text-14 px-3" onClick={this.showMoreTechnicians}>
                                        {t("show_more")} (+{Math.min(TECH_PAGE_SIZE, hiddenTechCount)})
                                    </button>
                                    <button type="button" className="btn btn-link p-0 text-primary text-decoration-none fw-bold text-14 px-2" onClick={this.showAllTechnicians}>
                                        {t("show_all_technicians")} ({displayedTechnicians.length})
                                    </button>
                                </div>
                            )}
                        </div>
                    )}
                </div>

                {/* คำอธิบายสี - แยกประเภทงาน CM/PM, กิจกรรม, และวันหยุดที่ย้อมพื้นหลังช่องไว้ */}
                <div className="d-flex flex-wrap gap-3 text-12 text-secondary mb-4">
                    <div className="d-flex align-items-center gap-2">
                        <span className="bg-orange rounded-1" style={{ width: 12, height: 12, display: "inline-block" }} />
                        {t("job_type_cm")}
                    </div>
                    <div className="d-flex align-items-center gap-2">
                        <span className="bg-primary rounded-1" style={{ width: 12, height: 12, display: "inline-block" }} />
                        {t("job_type_pm")}
                    </div>
                    <div className="d-flex align-items-center gap-2">
                        <span className="bg-teal-light border rounded-1" style={{ width: 12, height: 12, display: "inline-block" }} />
                        {t("activity_legend")}
                    </div>
                    <div className="d-flex align-items-center gap-2">
                        <span className="bg-secondary-light border rounded-1" style={{ width: 12, height: 12, display: "inline-block" }} />
                        {t("hd_company_holiday")}
                    </div>
                    <div className="d-flex align-items-center gap-2">
                        <span className="bg-danger-light border rounded-1" style={{ width: 12, height: 12, display: "inline-block" }} />
                        {t("hd_technician_holiday")}
                    </div>
                </div>

                {/* AI Scheduling Suggestions Panel */}
                {/* <div className="rounded-4 p-4 text-white" style={{ backgroundColor: "#1d4ed8" }}>
            <div className="d-flex justify-content-between align-items-start mb-3">
              <div>
                <h5 className="fw-bold mb-1 d-flex align-items-center">
                  <span className="icon me-2">{"\uf044"}</span> {t("ai_scheduling_suggestions")}
                </h5>
                <div className="text-12" style={{ color: "#bfdbfe" }}>
                  {t("ai_suggestions_desc")}
                </div>
              </div>
              <button className="btn btn-sm text-white border border-white-light d-flex align-items-center rounded-3 px-3" style={{ backgroundColor: "rgba(255,255,255,0.1)" }}>
                <span className="icon me-2">{"\uf021"}</span> {t("refresh")}
              </button>
            </div>

            <div className="d-flex flex-column gap-2">
              {aiSuggestions.map((sug, idx) => (
                <div key={idx} className="d-flex justify-content-between align-items-center rounded-3 p-3 border border-white" style={{ backgroundColor: "rgba(255,255,255,0.1)" }}>
                  <div>
                    <div className="fw-bold text-14 mb-1">{sug.wo}</div>
                    <div className="text-12" style={{ color: "#e2e8f0" }}>{sug.desc}</div>
                  </div>
                  <button className="btn btn-white bg-white text-dark fw-bold btn-sm px-4 rounded-pill">
                    {t("apply")}
                  </button>
                </div>
              ))}
            </div>
          </div> */}
            </div>
        </div>
    );
  }
}
